import { AnySet } from 'immer/dist/internal';
import React from 'react';

interface Props {
	id?: string;
	stroke?: string;
	hover?: boolean;
	width?: string;
	height?: string;
	style?: object;
	fill?: string;
}

// export function OnHover({ children, onHover, color }: any) {
// 	const [hover, setHover] = React.useState(false);
// 	return (
// 		<div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
// 			{React.Children.map(children, (child) => {
// 				return React.cloneElement(child, { hover, stroke: hover ? onHover : color });
// 			})}
// 		</div>
// 	);
// }
export function ShoppingCartIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.66663 1.66666H3.11663C4.01663 1.66666 4.72496 2.44166 4.64996 3.33333L3.95829 11.6333C3.84163 12.9917 4.91662 14.1583 6.28329 14.1583H15.1583C16.3583 14.1583 17.4083 13.175 17.5 11.9833L17.95 5.73333C18.05 4.35 17 3.22499 15.6083 3.22499H4.84997"
				stroke="#7D7D7D"
				strokeWidth="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M13.5417 18.3333C14.117 18.3333 14.5833 17.867 14.5833 17.2917C14.5833 16.7164 14.117 16.25 13.5417 16.25C12.9664 16.25 12.5 16.7164 12.5 17.2917C12.5 17.867 12.9664 18.3333 13.5417 18.3333Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M6.87504 18.3333C7.45034 18.3333 7.91671 17.867 7.91671 17.2917C7.91671 16.7164 7.45034 16.25 6.87504 16.25C6.29974 16.25 5.83337 16.7164 5.83337 17.2917C5.83337 17.867 6.29974 18.3333 6.87504 18.3333Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M7.5 6.66666H17.5"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function SettingsIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.3334 5.41667H13.3334"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M4.99996 5.41667H1.66663"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8.33329 8.33333C9.94412 8.33333 11.25 7.0275 11.25 5.41667C11.25 3.80584 9.94412 2.5 8.33329 2.5C6.72246 2.5 5.41663 3.80584 5.41663 5.41667C5.41663 7.0275 6.72246 8.33333 8.33329 8.33333Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3333 14.5833H15"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M6.66663 14.5833H1.66663"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M11.6667 17.5C13.2775 17.5 14.5833 16.1942 14.5833 14.5833C14.5833 12.9725 13.2775 11.6667 11.6667 11.6667C10.0558 11.6667 8.75 12.9725 8.75 14.5833C8.75 16.1942 10.0558 17.5 11.6667 17.5Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function DashboardIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M18.3333 9.08341V3.41675C18.3333 2.16675 17.8 1.66675 16.475 1.66675H13.1083C11.7833 1.66675 11.25 2.16675 11.25 3.41675V9.08341C11.25 10.3334 11.7833 10.8334 13.1083 10.8334H16.475C17.8 10.8334 18.3333 10.3334 18.3333 9.08341Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3333 16.5833V15.0833C18.3333 13.8333 17.8 13.3333 16.475 13.3333H13.1083C11.7833 13.3333 11.25 13.8333 11.25 15.0833V16.5833C11.25 17.8333 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8333 18.3333 16.5833Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8.75033 10.9167V16.5834C8.75033 17.8334 8.21699 18.3334 6.89199 18.3334H3.52533C2.20033 18.3334 1.66699 17.8334 1.66699 16.5834V10.9167C1.66699 9.66675 2.20033 9.16675 3.52533 9.16675H6.89199C8.21699 9.16675 8.75033 9.66675 8.75033 10.9167Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8.75033 3.41675V4.91675C8.75033 6.16675 8.21699 6.66675 6.89199 6.66675H3.52533C2.20033 6.66675 1.66699 6.16675 1.66699 4.91675V3.41675C1.66699 2.16675 2.20033 1.66675 3.52533 1.66675H6.89199C8.21699 1.66675 8.75033 2.16675 8.75033 3.41675Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function SupportIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.1666 15.3584H10.8333L7.12495 17.825C6.57495 18.1917 5.83329 17.8 5.83329 17.1334V15.3584C3.33329 15.3584 1.66663 13.6917 1.66663 11.1917V6.19166C1.66663 3.69166 3.33329 2.02499 5.83329 2.02499H14.1666C16.6666 2.02499 18.3333 3.69166 18.3333 6.19166V11.1917C18.3333 13.6917 16.6666 15.3584 14.1666 15.3584Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M10 9.46664V9.29168C10 8.72501 10.35 8.425 10.7 8.18333C11.0417 7.95 11.3833 7.65001 11.3833 7.10001C11.3833 6.33334 10.7667 5.71664 10 5.71664C9.23334 5.71664 8.6167 6.33334 8.6167 7.10001"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M9.99629 11.4583H10.0038"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function PriceCatalogIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.3334 5.00001V7.01667C18.3334 8.33334 17.5 9.16667 16.1834 9.16667H13.3334V3.34167C13.3334 2.41667 14.0917 1.66667 15.0167 1.66667C15.9251 1.67501 16.7584 2.04167 17.3584 2.64167C17.9584 3.25001 18.3334 4.08334 18.3334 5.00001Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M1.66663 5.83334V17.5C1.66663 18.1917 2.44994 18.5833 2.99994 18.1667L4.42496 17.1C4.75829 16.85 5.22496 16.8833 5.52496 17.1833L6.90827 18.575C7.23327 18.9 7.76664 18.9 8.09164 18.575L9.49164 17.175C9.7833 16.8833 10.25 16.85 10.575 17.1L12 18.1667C12.55 18.575 13.3333 18.1833 13.3333 17.5V3.33334C13.3333 2.41667 14.0833 1.66667 15 1.66667H5.83329H4.99996C2.49996 1.66667 1.66663 3.15834 1.66663 5.00001V5.83334Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M5 7.5H10"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M5.625 10.8333H9.375"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}
export function MessageIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.9833 8.99167V12.325C14.9833 12.5417 14.975 12.75 14.95 12.95C14.7583 15.2 13.4333 16.3167 10.9916 16.3167H10.6583C10.45 16.3167 10.25 16.4167 10.125 16.5833L9.12497 17.9167C8.6833 18.5083 7.96663 18.5083 7.52496 17.9167L6.52495 16.5833C6.41662 16.4417 6.17496 16.3167 5.99163 16.3167H5.6583C2.99997 16.3167 1.66663 15.6583 1.66663 12.325V8.99167C1.66663 6.55001 2.79163 5.22501 5.0333 5.03334C5.2333 5.00834 5.44163 5 5.6583 5H10.9916C13.65 5 14.9833 6.33334 14.9833 8.99167Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3167 5.65834V8.99167C18.3167 11.4417 17.1917 12.7583 14.95 12.95C14.975 12.75 14.9833 12.5417 14.9833 12.325V8.99167C14.9833 6.33334 13.65 5 10.9917 5H5.65833C5.44166 5 5.23333 5.00834 5.03333 5.03334C5.22499 2.79167 6.54999 1.66666 8.99166 1.66666H14.325C16.9833 1.66666 18.3167 3 18.3167 5.65834Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M11.2463 11.0417H11.2538"
				stroke="#1A1D1F"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8.32954 11.0417H8.33704"
				stroke="#1A1D1F"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M5.41292 11.0417H5.42042"
				stroke="#1A1D1F"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function ChevronRightIcon(props: Props) {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clip-path="url(#clip0_67_5573)">
				<path
					d="M2.625 11.375L7 7L2.625 2.625"
					stroke="#7D7D7D"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M7 11.375L11.375 7L7 2.625"
					stroke="#7D7D7D"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_67_5573">
					<rect
						width="14"
						height="14"
						fill="white"
						transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14 14)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
export function ChevronLeftIcon(props: Props) {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clip-path="url(#clip0_67_5316)">
				<path
					d="M11.375 11.375L7 7L11.375 2.625"
					stroke="#7D7D7D"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M7 11.375L2.625 7L7 2.625"
					stroke="#7D7D7D"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_67_5316">
					<rect width="14" height="14" fill="white" transform="translate(0 14) rotate(-90)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function SearchIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.16699 16.6665C13.3091 16.6665 16.667 13.3086 16.667 9.1665C16.667 5.02437 13.3091 1.6665 9.16699 1.6665C5.02486 1.6665 1.66699 5.02437 1.66699 9.1665C1.66699 13.3086 5.02486 16.6665 9.16699 16.6665Z"
				stroke="#7D7D7D"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.775 17.2413C16.2167 18.5747 17.225 18.708 18 17.5413C18.7084 16.4747 18.2417 15.5997 16.9584 15.5997C16.0084 15.5913 15.475 16.333 15.775 17.2413Z"
				stroke="#7D7D7D"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ArrowDown(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.58594 8.17529L9.99844 12.5753L14.4109 8.17529"
				stroke={props?.stroke || '#5C5C5C'}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ArrowUp(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.4141 12.8247L10.0016 8.42471L5.58906 12.8247"
				stroke={props?.stroke || '#1A1D1F'}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ArrowRight(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.17383 14.4141L11.5738 10.0016L7.17383 5.58906"
				stroke="#1A1D1F"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ArrowBack(props: Props) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.9743 12.9414L10.916 17.9997L15.9743 23.0581"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M25.0836 18H11.0586"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function EmptyListIllustration(props: Props) {
	return (
		<svg
			width="201"
			height="200"
			viewBox="0 0 201 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M138.964 36.0107C159.81 44.9181 159.463 73.6115 162.985 95.9902C166.081 115.658 170.687 137.741 157.292 152.466C144.415 166.62 122.586 161.045 103.441 161.443C83.3409 161.861 61.7444 167.88 46.4975 154.771C28.1006 138.953 12.8347 113.356 20.941 90.5105C28.7016 68.6397 58.8693 70.2391 79.9461 60.5064C100.291 51.1119 118.347 27.2004 138.964 36.0107Z"
				fill="#BCBCBC"
				fill-opacity="0.2"
			/>
			<path
				d="M57.8253 103.555H61.9483L63.0728 104.679L61.9483 117.798V135.415C61.9483 139.313 65.6966 145.785 67.5707 148.534H142.91C138.112 141.937 137.163 132.041 137.288 127.918V112.55L139.912 90.4359L142.91 69.071C144.409 65.7725 143.535 59.4505 142.91 56.7018L95.3076 55.9521H67.5707L66.4462 57.8263L62.698 55.9521L57.8253 57.8263L55.9512 63.4486V94.1841V100.931L57.8253 103.555Z"
				fill="white"
			/>
			<path
				d="M122.692 82.2363H79.2122C78.8145 82.2363 78.4332 82.3943 78.152 82.6755C77.8709 82.9566 77.7129 83.338 77.7129 83.7356C77.7129 84.1333 77.8709 84.5146 78.152 84.7958C78.4332 85.077 78.8145 85.2349 79.2122 85.2349H122.692C123.089 85.2349 123.471 85.077 123.752 84.7958C124.033 84.5146 124.191 84.1333 124.191 83.7356C124.191 83.338 124.033 82.9566 123.752 82.6755C123.471 82.3943 123.089 82.2363 122.692 82.2363Z"
				fill="#C7C7C7"
			/>
			<path
				d="M79.2122 92.7222H112.197C112.594 92.7222 112.976 92.5643 113.257 92.2831C113.538 92.0019 113.696 91.6206 113.696 91.2229C113.696 90.8253 113.538 90.4439 113.257 90.1628C112.976 89.8816 112.594 89.7236 112.197 89.7236H79.2122C78.8145 89.7236 78.4332 89.8816 78.152 90.1628C77.8709 90.4439 77.7129 90.8253 77.7129 91.2229C77.7129 91.6206 77.8709 92.0019 78.152 92.2831C78.4332 92.5643 78.8145 92.7222 79.2122 92.7222Z"
				fill="#C7C7C7"
			/>
			<path
				d="M122.692 97.2217H79.2122C78.8145 97.2217 78.4332 97.3796 78.152 97.6608C77.8709 97.942 77.7129 98.3233 77.7129 98.721C77.7129 99.1186 77.8709 99.5 78.152 99.7811C78.4332 100.062 78.8145 100.22 79.2122 100.22H122.692C123.089 100.22 123.471 100.062 123.752 99.7811C124.033 99.5 124.191 99.1186 124.191 98.721C124.191 98.3233 124.033 97.942 123.752 97.6608C123.471 97.3796 123.089 97.2217 122.692 97.2217Z"
				fill="#C7C7C7"
			/>
			<path
				d="M79.2122 107.716H112.197C112.594 107.716 112.976 107.558 113.257 107.277C113.538 106.996 113.696 106.615 113.696 106.217C113.696 105.819 113.538 105.438 113.257 105.157C112.976 104.876 112.594 104.718 112.197 104.718H79.2122C78.8145 104.718 78.4332 104.876 78.152 105.157C77.8709 105.438 77.7129 105.819 77.7129 106.217C77.7129 106.615 77.8709 106.996 78.152 107.277C78.4332 107.558 78.8145 107.716 79.2122 107.716Z"
				fill="#C7C7C7"
			/>
			<path
				d="M122.692 112.207H79.2122C78.8145 112.207 78.4332 112.365 78.152 112.646C77.8709 112.927 77.7129 113.309 77.7129 113.706C77.7129 114.104 77.8709 114.485 78.152 114.766C78.4332 115.048 78.8145 115.206 79.2122 115.206H122.692C123.089 115.206 123.471 115.048 123.752 114.766C124.033 114.485 124.191 114.104 124.191 113.706C124.191 113.309 124.033 112.927 123.752 112.646C123.471 112.365 123.089 112.207 122.692 112.207Z"
				fill="#C7C7C7"
			/>
			<path
				d="M79.2122 122.711H112.197C112.594 122.711 112.976 122.553 113.257 122.271C113.538 121.99 113.696 121.609 113.696 121.211C113.696 120.814 113.538 120.432 113.257 120.151C112.976 119.87 112.594 119.712 112.197 119.712H79.2122C78.8145 119.712 78.4332 119.87 78.152 120.151C77.8709 120.432 77.7129 120.814 77.7129 121.211C77.7129 121.609 77.8709 121.99 78.152 122.271C78.4332 122.553 78.8145 122.711 79.2122 122.711Z"
				fill="#C7C7C7"
			/>
			<path
				d="M122.692 127.198H79.2122C78.8145 127.198 78.4332 127.356 78.152 127.637C77.8709 127.919 77.7129 128.3 77.7129 128.698C77.7129 129.095 77.8709 129.477 78.152 129.758C78.4332 130.039 78.8145 130.197 79.2122 130.197H122.692C123.089 130.197 123.471 130.039 123.752 129.758C124.033 129.477 124.191 129.095 124.191 128.698C124.191 128.3 124.033 127.919 123.752 127.637C123.471 127.356 123.089 127.198 122.692 127.198Z"
				fill="#C7C7C7"
			/>
			<path
				d="M112.197 134.706H79.2122C78.8145 134.706 78.4332 134.864 78.152 135.145C77.8709 135.426 77.7129 135.808 77.7129 136.205C77.7129 136.603 77.8709 136.984 78.152 137.266C78.4332 137.547 78.8145 137.705 79.2122 137.705H112.197C112.594 137.705 112.976 137.547 113.257 137.266C113.538 136.984 113.696 136.603 113.696 136.205C113.696 135.808 113.538 135.426 113.257 135.145C112.976 134.864 112.594 134.706 112.197 134.706Z"
				fill="#C7C7C7"
			/>
			<path
				d="M122.692 67.2432H79.2122C78.8145 67.2432 78.4332 67.4011 78.152 67.6823C77.8709 67.9635 77.7129 68.3448 77.7129 68.7425C77.7129 69.1401 77.8709 69.5214 78.152 69.8026C78.4332 70.0838 78.8145 70.2418 79.2122 70.2418H122.692C123.089 70.2418 123.471 70.0838 123.752 69.8026C124.033 69.5214 124.191 69.1401 124.191 68.7425C124.191 68.3448 124.033 67.9635 123.752 67.6823C123.471 67.4011 123.089 67.2432 122.692 67.2432Z"
				fill="#C7C7C7"
			/>
			<path
				d="M79.2122 77.7281H112.197C112.594 77.7281 112.976 77.5701 113.257 77.2889C113.538 77.0078 113.696 76.6264 113.696 76.2288C113.696 75.8311 113.538 75.4498 113.257 75.1686C112.976 74.8875 112.594 74.7295 112.197 74.7295H79.2122C78.8145 74.7295 78.4332 74.8875 78.152 75.1686C77.8709 75.4498 77.7129 75.8311 77.7129 76.2288C77.7129 76.6264 77.8709 77.0078 78.152 77.2889C78.4332 77.5701 78.8145 77.7281 79.2122 77.7281Z"
				fill="#C7C7C7"
			/>
			<path
				d="M38.3587 150.438C39.1867 150.438 39.858 149.767 39.858 148.939C39.858 148.111 39.1867 147.439 38.3587 147.439C37.5306 147.439 36.8594 148.111 36.8594 148.939C36.8594 149.767 37.5306 150.438 38.3587 150.438Z"
				fill="#C7C7C7"
			/>
			<path
				d="M45.0881 147.439H42.8391C42.4415 147.439 42.0601 147.597 41.779 147.879C41.4978 148.16 41.3398 148.541 41.3398 148.939C41.3398 149.336 41.4978 149.718 41.779 149.999C42.0601 150.28 42.4415 150.438 42.8391 150.438H45.0881C45.4857 150.438 45.8671 150.28 46.1482 149.999C46.4294 149.718 46.5874 149.336 46.5874 148.939C46.5874 148.541 46.4294 148.16 46.1482 147.879C45.8671 147.597 45.4857 147.439 45.0881 147.439Z"
				fill="#C7C7C7"
			/>
			<path
				d="M125.452 153.453H119.224C118.846 153.482 118.494 153.653 118.236 153.931C117.979 154.209 117.836 154.574 117.836 154.952C117.836 155.331 117.979 155.696 118.236 155.974C118.494 156.252 118.846 156.422 119.224 156.452H125.452C125.829 156.422 126.182 156.252 126.439 155.974C126.697 155.696 126.839 155.331 126.839 154.952C126.839 154.574 126.697 154.209 126.439 153.931C126.182 153.653 125.829 153.482 125.452 153.453ZM80.4731 153.453H74.245C73.8674 153.482 73.5148 153.653 73.2575 153.931C73.0003 154.209 72.8574 154.574 72.8574 154.952C72.8574 155.331 73.0003 155.696 73.2575 155.974C73.5148 156.252 73.8674 156.422 74.245 156.452H80.4731C80.8506 156.422 81.2033 156.252 81.4605 155.974C81.7177 155.696 81.8606 155.331 81.8606 154.952C81.8606 154.574 81.7177 154.209 81.4605 153.931C81.2033 153.653 80.8506 153.482 80.4731 153.453ZM114.841 153.453H84.8555C84.4578 153.453 84.0765 153.611 83.7953 153.892C83.5142 154.173 83.3562 154.555 83.3562 154.952C83.3562 155.35 83.5142 155.731 83.7953 156.013C84.0765 156.294 84.4578 156.452 84.8555 156.452H96.8049V157.951H90.8527C90.455 157.951 90.0737 158.109 89.7925 158.39C89.5113 158.671 89.3534 159.053 89.3534 159.45C89.3534 159.848 89.5113 160.229 89.7925 160.51C90.0737 160.792 90.455 160.95 90.8527 160.95H109.594C109.991 160.95 110.373 160.792 110.654 160.51C110.935 160.229 111.093 159.848 111.093 159.45C111.093 159.053 110.935 158.671 110.654 158.39C110.373 158.109 109.991 157.951 109.594 157.951H102.892V156.452H114.841C115.239 156.452 115.62 156.294 115.902 156.013C116.183 155.731 116.341 155.35 116.341 154.952C116.341 154.555 116.183 154.173 115.902 153.892C115.62 153.611 115.239 153.453 114.841 153.453Z"
				fill="#C7C7C7"
			/>
			<path
				d="M156.787 147.439H154.538C154.141 147.439 153.759 147.597 153.478 147.879C153.197 148.16 153.039 148.541 153.039 148.939C153.039 149.336 153.197 149.718 153.478 149.999C153.759 150.28 154.141 150.438 154.538 150.438H156.787C157.185 150.438 157.566 150.28 157.847 149.999C158.129 149.718 158.287 149.336 158.287 148.939C158.287 148.541 158.129 148.16 157.847 147.879C157.566 147.597 157.185 147.439 156.787 147.439Z"
				fill="#C7C7C7"
			/>
			<path
				d="M161.296 150.438C162.124 150.438 162.795 149.767 162.795 148.939C162.795 148.111 162.124 147.439 161.296 147.439C160.468 147.439 159.797 148.111 159.797 148.939C159.797 149.767 160.468 150.438 161.296 150.438Z"
				fill="#C7C7C7"
			/>
			<path
				d="M149.835 147.439H144.317C134.444 135.814 139.277 104.316 142.825 81.2228C143.816 74.7796 144.672 69.2157 145.112 64.7448C145.289 63.2786 145.164 61.7916 144.745 60.3756C144.325 58.9596 143.619 57.6447 142.671 56.5122C142.164 55.9034 141.535 55.408 140.824 55.0582C140.114 54.7085 139.337 54.5122 138.546 54.4822C138.415 54.5088 138.28 54.5088 138.149 54.4822H63.7347C63.6782 54.4847 63.6219 54.4904 63.566 54.4994C63.4723 54.4934 63.3794 54.4822 63.2857 54.4822C58.0921 54.4822 54.4638 58.642 54.4638 64.5972V99.7256C54.4314 101.054 54.9269 102.342 55.8419 103.306C56.7569 104.271 58.0167 104.833 59.3455 104.87H61.2976C59.5337 121.596 59.4152 138.204 65.3269 147.438H49.801C49.5877 147.41 49.3709 147.428 49.1651 147.491C48.9593 147.554 48.7693 147.659 48.6076 147.801C48.4459 147.943 48.3164 148.118 48.2277 148.314C48.139 148.51 48.0931 148.722 48.0931 148.938C48.0931 149.153 48.139 149.365 48.2277 149.561C48.3164 149.757 48.4459 149.932 48.6076 150.074C48.7693 150.216 48.9593 150.322 49.1651 150.384C49.3709 150.447 49.5877 150.465 49.801 150.437H149.834C150.047 150.465 150.264 150.447 150.47 150.384C150.676 150.322 150.866 150.216 151.027 150.074C151.189 149.932 151.318 149.757 151.407 149.561C151.496 149.365 151.542 149.153 151.542 148.938C151.542 148.722 151.496 148.51 151.407 148.314C151.318 148.118 151.189 147.943 151.027 147.801C150.866 147.659 150.676 147.554 150.47 147.491C150.264 147.428 150.047 147.41 149.834 147.438L149.835 147.439ZM59.3455 101.871C58.8123 101.833 58.3154 101.587 57.9629 101.185C57.6103 100.783 57.4305 100.258 57.4624 99.7248V64.5964C57.4624 61.3137 58.9879 57.48 63.2857 57.48C63.6578 57.5148 64.0188 57.6256 64.3463 57.8056C64.6739 57.9856 64.9609 58.231 65.1898 58.5265C65.8554 59.349 66.3473 60.298 66.6357 61.316C66.924 62.3341 67.0029 63.4001 66.8675 64.4495C66.4349 68.8394 65.5856 74.3665 64.602 80.767C63.5923 87.3384 62.4798 94.574 61.6304 101.871H59.3455ZM69.0332 147.438C59.1753 135.802 64.0181 104.306 67.5654 81.222C68.5564 74.7788 69.411 69.215 69.8518 64.7441C70.1349 62.2 69.5364 59.6358 68.1561 57.48H138.149C138.28 57.4533 138.415 57.4533 138.546 57.48C138.918 57.5149 139.279 57.6258 139.606 57.8056C139.933 57.9855 140.22 58.2306 140.449 58.5258C141.115 59.3483 141.607 60.2974 141.896 61.3156C142.184 62.3337 142.263 63.3998 142.128 64.4495C141.696 68.8401 140.846 74.3673 139.862 80.767C136.4 103.289 131.739 133.619 140.583 147.438H69.0332ZM146.039 42.574C146.484 42.574 146.919 42.4422 147.289 42.195C147.658 41.9479 147.947 41.5967 148.117 41.1857C148.287 40.7748 148.332 40.3226 148.245 39.8864C148.158 39.4501 147.944 39.0494 147.629 38.7349C147.315 38.4204 146.914 38.2062 146.478 38.1194C146.042 38.0326 145.589 38.0771 145.178 38.2474C144.768 38.4176 144.416 38.7058 144.169 39.0757C143.922 39.4455 143.79 39.8803 143.79 40.3251C143.791 40.9214 144.028 41.4931 144.45 41.9147C144.871 42.3363 145.443 42.5735 146.039 42.574ZM146.039 39.2006C146.262 39.2006 146.479 39.2666 146.664 39.3901C146.849 39.5137 146.993 39.6893 147.078 39.8948C147.163 40.1003 147.185 40.3264 147.142 40.5445C147.099 40.7626 146.992 40.963 146.834 41.1202C146.677 41.2775 146.477 41.3846 146.258 41.428C146.04 41.4714 145.814 41.4491 145.609 41.364C145.403 41.2789 145.228 41.1348 145.104 40.9498C144.981 40.7649 144.915 40.5475 144.915 40.3251C144.915 40.0269 145.033 39.741 145.244 39.5302C145.455 39.3194 145.741 39.2008 146.039 39.2006ZM158.29 93.9923C157.993 93.9923 157.703 94.0802 157.457 94.2449C157.21 94.4097 157.018 94.6439 156.905 94.9178C156.791 95.1918 156.762 95.4932 156.819 95.7841C156.877 96.0749 157.02 96.342 157.23 96.5517C157.439 96.7614 157.707 96.9042 157.997 96.9621C158.288 97.0199 158.59 96.9902 158.864 96.8767C159.138 96.7633 159.372 96.5711 159.536 96.3245C159.701 96.078 159.789 95.7881 159.789 95.4916C159.789 95.0941 159.631 94.7129 159.35 94.4318C159.068 94.1508 158.687 93.9927 158.29 93.9923ZM158.29 96.2412C158.142 96.2412 157.997 96.1973 157.873 96.1149C157.75 96.0325 157.654 95.9154 157.597 95.7784C157.541 95.6415 157.526 95.4907 157.555 95.3453C157.584 95.1999 157.655 95.0663 157.76 94.9615C157.865 94.8566 157.998 94.7853 158.144 94.7563C158.289 94.7274 158.44 94.7422 158.577 94.799C158.714 94.8557 158.831 94.9518 158.913 95.0751C158.996 95.1984 159.039 95.3433 159.039 95.4916C159.039 95.6903 158.96 95.8809 158.82 96.0214C158.679 96.162 158.489 96.241 158.29 96.2412ZM41.345 40.9893C41.0485 40.9893 40.7586 41.0772 40.512 41.242C40.2655 41.4067 40.0733 41.6409 39.9598 41.9148C39.8464 42.1888 39.8167 42.4903 39.8745 42.7811C39.9324 43.0719 40.0752 43.3391 40.2848 43.5487C40.4945 43.7584 40.7617 43.9012 41.0525 43.9591C41.3433 44.0169 41.6448 43.9872 41.9188 43.8738C42.1927 43.7603 42.4269 43.5681 42.5916 43.3216C42.7564 43.075 42.8443 42.7851 42.8443 42.4886C42.8439 42.0911 42.6858 41.71 42.4047 41.4289C42.1236 41.1478 41.7425 40.9897 41.345 40.9893ZM41.345 43.2382C41.1967 43.2382 41.0518 43.1943 40.9285 43.1119C40.8052 43.0295 40.7092 42.9124 40.6524 42.7755C40.5957 42.6385 40.5808 42.4878 40.6098 42.3423C40.6387 42.1969 40.7101 42.0633 40.8149 41.9585C40.9198 41.8537 41.0533 41.7823 41.1987 41.7533C41.3442 41.7244 41.4949 41.7393 41.6319 41.796C41.7689 41.8527 41.8859 41.9488 41.9683 42.0721C42.0507 42.1954 42.0946 42.3403 42.0946 42.4886C42.0944 42.6873 42.0154 42.8779 41.8749 43.0184C41.7343 43.159 41.5438 43.238 41.345 43.2382Z"
				fill="#C7C7C7"
			/>
			<path
				d="M147.547 73.2344C147.25 73.2344 146.96 73.3223 146.714 73.4871C146.467 73.6518 146.275 73.886 146.162 74.16C146.048 74.4339 146.018 74.7354 146.076 75.0262C146.134 75.317 146.277 75.5842 146.487 75.7939C146.696 76.0035 146.963 76.1463 147.254 76.2042C147.545 76.262 147.846 76.2324 148.12 76.1189C148.394 76.0054 148.629 75.8132 148.793 75.5667C148.958 75.3201 149.046 75.0302 149.046 74.7337C149.046 74.3362 148.888 73.9551 148.606 73.674C148.325 73.3929 147.944 73.2348 147.547 73.2344ZM147.547 75.4834C147.398 75.4834 147.254 75.4394 147.13 75.357C147.007 75.2746 146.911 75.1576 146.854 75.0206C146.797 74.8836 146.783 74.7329 146.811 74.5875C146.84 74.442 146.912 74.3085 147.017 74.2036C147.121 74.0988 147.255 74.0274 147.4 73.9985C147.546 73.9695 147.697 73.9844 147.834 74.0411C147.971 74.0979 148.088 74.1939 148.17 74.3172C148.252 74.4405 148.296 74.5854 148.296 74.7337C148.296 74.9325 148.217 75.123 148.077 75.2636C147.936 75.4041 147.745 75.4832 147.547 75.4834ZM63.9537 49.9954C63.9537 49.6989 63.8657 49.409 63.701 49.1624C63.5362 48.9159 63.3021 48.7237 63.0281 48.6102C62.7542 48.4967 62.4527 48.4671 62.1619 48.5249C61.871 48.5828 61.6039 48.7255 61.3942 48.9352C61.1845 49.1449 61.0417 49.4121 60.9839 49.7029C60.926 49.9937 60.9557 50.2952 61.0692 50.5691C61.1827 50.8431 61.3749 51.0773 61.6214 51.242C61.868 51.4067 62.1578 51.4947 62.4544 51.4947C62.8519 51.4943 63.233 51.3362 63.5141 51.0551C63.7952 50.774 63.9533 50.3929 63.9537 49.9954ZM61.7047 49.9954C61.7047 49.8471 61.7487 49.7022 61.8311 49.5789C61.9134 49.4556 62.0305 49.3595 62.1675 49.3028C62.3045 49.2461 62.4552 49.2312 62.6006 49.2601C62.746 49.2891 62.8796 49.3605 62.9845 49.4653C63.0893 49.5701 63.1607 49.7037 63.1896 49.8491C63.2185 49.9946 63.2037 50.1453 63.147 50.2823C63.0902 50.4192 62.9941 50.5363 62.8709 50.6187C62.7476 50.7011 62.6026 50.745 62.4544 50.745C62.2556 50.7448 62.0651 50.6658 61.9245 50.5252C61.784 50.3847 61.7049 50.1941 61.7047 49.9954Z"
				fill="#C7C7C7"
			/>
			<path
				d="M45.0147 88.2328L46.1294 86.7672L45.4255 86.3684L44.7096 88.0101H44.6864L43.9592 86.3797L43.2433 86.7905L44.346 88.2215V88.2448L42.6211 88.0221V88.8198L44.3573 88.5971V88.6204L43.2433 90.0507L43.9112 90.4735L44.6744 88.8198H44.6976L45.4015 90.4615L46.1407 90.0394L45.0147 88.6316V88.6084L46.7854 88.8198V88.0221L45.0147 88.2568V88.2328ZM90.6277 39.2666L89.986 40.0905L90.3713 40.3334L90.8106 39.3813H90.8241L91.2289 40.3266L91.6547 40.0837L91.0063 39.2734V39.2599L92.0258 39.3813V38.9218L91.0063 39.0567V39.0432L91.648 38.1991L91.2432 37.9697L90.8309 38.915H90.8174L90.3991 37.9765L89.986 38.2126L90.6217 39.0365V39.05L89.6284 38.9218V39.3813L90.6277 39.2531V39.2666ZM160.337 57.9088V57.1269L158.6 57.3563V57.3339L159.694 55.896L159.004 55.5047L158.302 57.115H158.278L157.566 55.516L156.863 55.9185L157.945 57.3226V57.3451L156.253 57.1269V57.9088L157.956 57.6907V57.7132L156.863 59.1165L157.519 59.5311L158.268 57.9088H158.289L158.98 59.5198L159.705 59.1053L158.6 57.7244V57.7019L160.337 57.9088ZM118.077 49.8336L119.021 48.5937L118.425 48.2556L117.82 49.6447H117.8L117.185 48.2654L116.579 48.6132L117.512 49.8239V49.8441L116.053 49.6552V50.3299L117.522 50.1417V50.1612L116.579 51.3719L117.144 51.7295L117.79 50.3299H117.81L118.405 51.719L119.03 51.3622L118.077 50.171V50.1515L119.576 50.3299V49.6552L118.077 49.8539V49.8336Z"
				fill="#C7C7C7"
			/>
			<path
				d="M147.285 56.6222V61.3225C147.285 62.0921 146.873 62.8068 146.206 63.1985L142.124 65.5555C141.458 65.9403 140.633 65.9403 139.96 65.5555L135.878 63.1985C135.211 62.8137 134.799 62.099 134.799 61.3225V56.6222C134.799 55.8526 135.211 55.1379 135.878 54.7462L139.96 52.3892C140.626 52.0044 141.451 52.0044 142.124 52.3892L146.206 54.7462C146.873 55.1379 147.285 55.8457 147.285 56.6222Z"
				fill="#F7A0B5"
			/>
			<path
				d="M139.683 60.6741L142.441 57.4955"
				stroke="white"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M142.651 60.4636L139.473 57.7061"
				stroke="white"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function InfoCircleIcon(
	props: Props,
	fill?: string = '#979797',
	width?: string = '20',
	height?: string = '20'
) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.0007 18.333C14.5923 18.333 18.334 14.5913 18.334 9.99967C18.334 5.40801 14.5923 1.66634 10.0007 1.66634C5.40899 1.66634 1.66732 5.40801 1.66732 9.99967C1.66732 14.5913 5.40898 18.333 10.0007 18.333ZM10.6257 13.333C10.6257 13.6747 10.3423 13.958 10.0007 13.958C9.65898 13.958 9.37565 13.6747 9.37565 13.333L9.37565 9.16634C9.37565 8.82467 9.65899 8.54134 10.0007 8.54134C10.3423 8.54134 10.6257 8.82467 10.6257 9.16634L10.6257 13.333ZM9.23399 6.34967C9.27565 6.24134 9.33399 6.15801 9.40899 6.07467C9.49232 5.99967 9.58399 5.94134 9.68399 5.89967C9.78399 5.85801 9.89232 5.83301 10.0007 5.83301C10.109 5.83301 10.2173 5.85801 10.3173 5.89967C10.4173 5.94134 10.509 5.99968 10.5923 6.07467C10.6673 6.15801 10.7257 6.24134 10.7673 6.34967C10.809 6.44967 10.834 6.55801 10.834 6.66634C10.834 6.77467 10.809 6.88301 10.7673 6.98301C10.7257 7.08301 10.6673 7.17467 10.5923 7.25801C10.509 7.33301 10.4173 7.39134 10.3173 7.43301C10.1173 7.51634 9.88399 7.51634 9.68399 7.43301C9.58399 7.39134 9.49232 7.33301 9.40899 7.25801C9.33399 7.17467 9.27565 7.08301 9.23399 6.98301C9.19232 6.88301 9.16732 6.77467 9.16732 6.66634C9.16732 6.55801 9.19232 6.44967 9.23399 6.34967Z"
				fill={fill}
				{...props}
			/>
		</svg>
	);
}

export function DuplicateIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M13.3337 10.75V14.25C13.3337 17.1667 12.167 18.3334 9.25033 18.3334H5.75033C2.83366 18.3334 1.66699 17.1667 1.66699 14.25V10.75C1.66699 7.83335 2.83366 6.66669 5.75033 6.66669H9.25033C12.167 6.66669 13.3337 7.83335 13.3337 10.75Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3337 5.75002V9.25002C18.3337 12.1667 17.167 13.3334 14.2503 13.3334H13.3337V10.75C13.3337 7.83335 12.167 6.66669 9.25033 6.66669H6.66699V5.75002C6.66699 2.83335 7.83366 1.66669 10.7503 1.66669H14.2503C17.167 1.66669 18.3337 2.83335 18.3337 5.75002Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function EditIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M11.0495 3.00002L4.2078 10.2417C3.94947 10.5167 3.69947 11.0584 3.64947 11.4334L3.34114 14.1333C3.2328 15.1083 3.9328 15.775 4.89947 15.6084L7.5828 15.15C7.9578 15.0834 8.4828 14.8084 8.74114 14.525L15.5828 7.28335C16.7661 6.03335 17.2995 4.60835 15.4578 2.86668C13.6245 1.14168 12.2328 1.75002 11.0495 3.00002Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M9.9082 4.20831C10.2665 6.50831 12.1332 8.26665 14.4499 8.49998"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M2.5 18.3333H17.5"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function TickIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M4 10L7.99529 14L16 6"
				stroke="#00C853"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function CrossIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M5.99805 14.0001L13.998 6.00012"
				stroke="#F26184"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M13.998 14.0001L5.99805 6.00012"
				stroke="#F26184"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function ModalCloseIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function DeleteIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M17.5574 4.35829C16.2157 4.22496 14.8741 4.12496 13.5241 4.04996V4.04163L13.3407 2.95829C13.2157 2.19163 13.0324 1.04163 11.0824 1.04163H8.89907C6.95741 1.04163 6.77407 2.14163 6.64074 2.94996L6.46574 4.01663C5.69074 4.06663 4.91574 4.11663 4.14074 4.19163L2.44074 4.35829C2.09074 4.39163 1.84074 4.69996 1.87407 5.04163C1.90741 5.38329 2.20741 5.63329 2.55741 5.59996L4.25741 5.43329C8.62407 4.99996 13.0241 5.16663 17.4407 5.60829C17.4657 5.60829 17.4824 5.60829 17.5074 5.60829C17.8241 5.60829 18.0991 5.36663 18.1324 5.04163C18.1574 4.69996 17.9074 4.39163 17.5574 4.35829Z"
				fill="#F26184"
			/>
			<path
				d="M16.0245 6.78337C15.8245 6.57504 15.5495 6.45837 15.2661 6.45837H4.7328C4.44947 6.45837 4.16613 6.57504 3.97447 6.78337C3.7828 6.99171 3.67447 7.27504 3.69113 7.56671L4.2078 16.1167C4.29947 17.3834 4.41613 18.9667 7.32447 18.9667H12.6745C15.5828 18.9667 15.6995 17.3917 15.7911 16.1167L16.3078 7.57504C16.3245 7.27504 16.2161 6.99171 16.0245 6.78337ZM11.3828 14.7917H8.6078C8.26613 14.7917 7.9828 14.5084 7.9828 14.1667C7.9828 13.825 8.26613 13.5417 8.6078 13.5417H11.3828C11.7245 13.5417 12.0078 13.825 12.0078 14.1667C12.0078 14.5084 11.7245 14.7917 11.3828 14.7917ZM12.0828 11.4584H7.91613C7.57447 11.4584 7.29113 11.175 7.29113 10.8334C7.29113 10.4917 7.57447 10.2084 7.91613 10.2084H12.0828C12.4245 10.2084 12.7078 10.4917 12.7078 10.8334C12.7078 11.175 12.4245 11.4584 12.0828 11.4584Z"
				fill="#F26184"
			/>
		</svg>
	);
}
export function CatalogsIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M18.3337 3.89168V13.95C18.3337 14.75 17.6837 15.5 16.8837 15.6L16.6087 15.6334C14.792 15.875 11.992 16.8 10.392 17.6833C10.1753 17.8083 9.817 17.8083 9.592 17.6833L9.55863 17.6667C7.95863 16.7917 5.16702 15.875 3.35868 15.6334L3.11698 15.6C2.31698 15.5 1.66699 14.75 1.66699 13.95V3.88334C1.66699 2.89167 2.4753 2.14168 3.46697 2.22502C5.21697 2.36668 7.86697 3.25004 9.3503 4.17504L9.55863 4.30001C9.8003 4.45001 10.2003 4.45001 10.442 4.30001L10.5837 4.20835C11.1087 3.88335 11.7753 3.55835 12.5003 3.26668V6.6667L14.167 5.55835L15.8337 6.6667V2.31672C16.0587 2.27505 16.2753 2.25002 16.4753 2.23336H16.5253C17.517 2.15002 18.3337 2.89168 18.3337 3.89168Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M10 4.57501V17.075"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M15.8333 2.31671V6.66669L14.1667 5.55834L12.5 6.66669V3.26667C13.5917 2.83334 14.8083 2.48338 15.8333 2.31671Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function CalenderIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M6.66699 1.66675V4.16675"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M13.333 1.66675V4.16675"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M2.91699 7.57507H17.0837"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.5 7.08341V14.1667C17.5 16.6667 16.25 18.3334 13.3333 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V7.08341C2.5 4.58341 3.75 2.91675 6.66667 2.91675H13.3333C16.25 2.91675 17.5 4.58341 17.5 7.08341Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.99607 11.4167H10.0036"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.91209 11.4167H6.91957"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.91209 13.9167H6.91957"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function FilterIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.66732 15.8335L10.834 15.8335"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.1673 15.8335L18.334 15.8335"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M1.66732 10L5.83398 10"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.16732 10L18.334 10"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M1.66732 4.1665L10.834 4.1665"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.1673 4.1665L18.334 4.1665"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.834 2.5L10.834 5.83333"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.834 14.1665L10.834 17.4998"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.16602 8.3335L9.16602 11.6668"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function CloseIcon(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function EmptyItem(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={props?.width || '201'}
			height={props?.height || '200'}
			viewBox="0 0 201 200"
			fill="none"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M138.915 35.9863C159.76 44.8938 159.414 73.5871 162.936 95.9658C166.031 115.634 170.638 137.717 157.243 152.441C144.366 166.596 122.536 161.02 103.392 161.419C83.2915 161.837 61.695 167.855 46.4481 154.746C28.0512 138.929 12.7853 113.331 20.8916 90.4862C28.6522 68.6154 68.3729 87.2084 89.4497 77.4757C109.794 68.0813 118.297 27.1761 138.915 35.9863Z"
				fill="#BCBCBC"
				fill-opacity="0.2"
			/>
			<path
				d="M133.193 61.6043C133.638 61.6043 134.073 61.4724 134.443 61.2253C134.813 60.9782 135.101 60.627 135.271 60.216C135.441 59.8051 135.486 59.3529 135.399 58.9166C135.312 58.4804 135.098 58.0797 134.784 57.7651C134.469 57.4506 134.068 57.2364 133.632 57.1497C133.196 57.0629 132.744 57.1074 132.333 57.2776C131.922 57.4479 131.571 57.7361 131.323 58.1059C131.076 58.4758 130.944 58.9106 130.944 59.3554C130.945 59.9517 131.182 60.5233 131.604 60.945C132.025 61.3666 132.597 61.6037 133.193 61.6043ZM133.193 58.2309C133.416 58.2309 133.633 58.2969 133.818 58.4204C134.003 58.544 134.147 58.7196 134.232 58.9251C134.317 59.1305 134.34 59.3566 134.296 59.5748C134.253 59.7929 134.146 59.9932 133.989 60.1505C133.831 60.3078 133.631 60.4149 133.413 60.4582C133.195 60.5016 132.969 60.4794 132.763 60.3943C132.558 60.3091 132.382 60.165 132.258 59.9801C132.135 59.7952 132.069 59.5778 132.069 59.3554C132.069 59.0572 132.188 58.7713 132.399 58.5605C132.609 58.3496 132.895 58.2311 133.193 58.2309ZM145.444 113.023C145.148 113.023 144.858 113.11 144.611 113.275C144.365 113.44 144.172 113.674 144.059 113.948C143.945 114.222 143.916 114.524 143.974 114.814C144.032 115.105 144.174 115.372 144.384 115.582C144.594 115.792 144.861 115.934 145.152 115.992C145.442 116.05 145.744 116.02 146.018 115.907C146.292 115.794 146.526 115.601 146.691 115.355C146.855 115.108 146.943 114.818 146.943 114.522C146.943 114.124 146.785 113.743 146.504 113.462C146.223 113.181 145.842 113.023 145.444 113.023ZM145.444 115.271C145.296 115.271 145.151 115.228 145.028 115.145C144.904 115.063 144.808 114.946 144.752 114.809C144.695 114.672 144.68 114.521 144.709 114.376C144.738 114.23 144.809 114.097 144.914 113.992C145.019 113.887 145.152 113.816 145.298 113.787C145.443 113.758 145.594 113.773 145.731 113.829C145.868 113.886 145.985 113.982 146.067 114.105C146.15 114.229 146.194 114.374 146.194 114.522C146.194 114.721 146.115 114.911 145.974 115.052C145.833 115.192 145.643 115.271 145.444 115.271ZM28.4993 60.0196C28.2028 60.0196 27.9129 60.1075 27.6663 60.2722C27.4198 60.437 27.2276 60.6711 27.1141 60.9451C27.0006 61.2191 26.971 61.5205 27.0288 61.8114C27.0867 62.1022 27.2295 62.3693 27.4391 62.579C27.6488 62.7887 27.916 62.9315 28.2068 62.9893C28.4976 63.0472 28.7991 63.0175 29.073 62.904C29.347 62.7905 29.5812 62.5984 29.7459 62.3518C29.9107 62.1053 29.9986 61.8154 29.9986 61.5189C29.9982 61.1213 29.8401 60.7402 29.559 60.4591C29.2779 60.1781 28.8968 60.02 28.4993 60.0196ZM28.4993 62.2685C28.351 62.2685 28.2061 62.2245 28.0828 62.1422C27.9595 62.0598 27.8634 61.9427 27.8067 61.8057C27.75 61.6688 27.7351 61.518 27.7641 61.3726C27.793 61.2272 27.8644 61.0936 27.9692 60.9888C28.0741 60.8839 28.2076 60.8125 28.353 60.7836C28.4985 60.7547 28.6492 60.7695 28.7862 60.8263C28.9232 60.883 29.0402 60.9791 29.1226 61.1024C29.205 61.2257 29.2489 61.3706 29.2489 61.5189C29.2487 61.7176 29.1697 61.9082 29.0292 62.0487C28.8886 62.1893 28.6981 62.2683 28.4993 62.2685Z"
				fill="#C7C7C7"
			/>
			<path
				d="M31.169 96.2631L32.2837 94.7975L31.5798 94.3987L30.8639 96.0404H30.8407L30.1135 94.4099L29.3976 94.8207L30.5003 96.2518V96.2751L28.7754 96.0524V96.85L30.5116 96.6274V96.6506L29.3976 98.081L30.0655 98.5038L30.8287 96.85H30.8519L31.5558 98.4918L32.295 98.0697L31.169 96.6619V96.6386L32.9397 96.85V96.0524L31.169 96.287V96.2631ZM76.782 47.2969L76.1403 48.1208L76.5256 48.3636L76.9649 47.4116H76.9784L77.3832 48.3569L77.809 48.114L77.1606 47.3036V47.2901L78.1801 47.4116V46.9521L77.1606 47.087V47.0735L77.8023 46.2294L77.3975 46L76.9851 46.9453H76.9717L76.5534 46.0067L76.1403 46.2429L76.776 47.0667V47.0802L75.7827 46.9521V47.4116L76.782 47.2834V47.2969ZM146.492 65.9391V65.1572L144.755 65.3866V65.3641L145.848 63.9263L145.158 63.535L144.456 65.1452H144.432L143.72 63.5462L143.017 63.9488L144.099 65.3529V65.3754L142.408 65.1572V65.9391L144.111 65.721V65.7434L143.017 67.1468L143.673 67.5613L144.422 65.9391H144.444L145.134 67.5501L145.86 67.1355L144.755 65.7547V65.7322L146.492 65.9391ZM104.232 57.8639L105.175 56.624L104.58 56.2859L103.975 57.675H103.954L103.339 56.2956L102.733 56.6435L103.667 57.8542V57.8744L102.207 57.6855V58.3602L103.676 58.172V58.1915L102.733 59.4022L103.298 59.7598L103.945 58.3602H103.964L104.559 59.7493L105.185 59.3924L104.232 58.2013V58.1818L105.73 58.3602V57.6855L104.232 57.8841V57.8639Z"
				fill="#C7C7C7"
			/>
			<path
				d="M68.1055 71.1468L100.58 63.0281C107.075 71.9587 138.468 85.6929 153.352 91.4436L139.144 105.651L150.307 110.726L138.129 122.904L145.233 125.948C136.303 139.75 105.655 156.055 91.4468 162.482C78.4569 157.611 49.5001 121.889 36.6455 104.637H51.8681L40.7049 89.4139L57.9571 88.3991L45.7791 70.132L52.8829 71.1468H68.1055Z"
				fill="white"
			/>
			<path
				d="M155.057 89.6291C137.622 84.9608 118.847 75.2062 100.759 61.4166C100.482 61.2052 100.155 61.0686 99.8106 61.0199C99.4658 60.9712 99.1143 61.0121 98.7898 61.1385C80.2893 68.3642 61.6345 70.8667 44.8491 68.3743C44.459 68.3226 44.0624 68.3847 43.7067 68.5529C43.351 68.7212 43.0515 68.9885 42.844 69.3228C42.6366 69.6572 42.53 70.0443 42.5372 70.4377C42.5443 70.8311 42.6649 71.214 42.8844 71.5406C46.7408 77.0911 50.7325 82.4305 54.8595 87.5588C50.1741 87.6199 45.4913 87.3104 40.8547 86.6333C40.4641 86.5798 40.0663 86.6405 39.7094 86.8082C39.3526 86.9758 39.0519 87.2432 38.8437 87.5781C38.6355 87.9129 38.5287 88.3009 38.5362 88.6951C38.5437 89.0893 38.6651 89.4729 38.8859 89.7996C42.0295 94.2961 45.2985 98.7036 48.6892 103.017C44.7065 102.979 40.7308 102.672 36.7893 102.099C36.3995 102.049 36.0034 102.111 35.6484 102.28C35.2934 102.449 34.9945 102.716 34.7876 103.05C34.5807 103.384 34.4745 103.771 34.4818 104.164C34.4891 104.557 34.6095 104.939 34.8286 105.266C50.1335 127.635 68.8305 147.482 90.2469 164.094C90.5237 164.305 90.8503 164.441 91.1951 164.49C91.54 164.538 91.8914 164.497 92.2157 164.37C113.206 155.866 132.171 143.036 147.873 126.715C148.117 126.461 148.29 126.147 148.376 125.806C148.463 125.464 148.459 125.106 148.367 124.766C148.274 124.427 148.095 124.117 147.847 123.866C147.599 123.616 147.291 123.434 146.952 123.338C144.963 122.795 142.989 122.2 141.031 121.554C144.8 118.306 148.454 114.878 151.994 111.27C152.241 111.016 152.418 110.702 152.507 110.359C152.596 110.016 152.593 109.655 152.499 109.314C152.406 108.972 152.224 108.661 151.972 108.411C151.721 108.161 151.409 107.982 151.066 107.89C148.248 107.118 145.462 106.237 142.712 105.249C147.343 101.4 151.772 97.3141 155.982 93.0085C156.226 92.7534 156.399 92.4396 156.486 92.0977C156.572 91.7557 156.568 91.3972 156.475 91.057C156.382 90.7168 156.202 90.4065 155.954 90.1563C155.705 89.9061 155.396 89.7244 155.057 89.6291ZM142.552 126.305C128.017 140.81 110.773 152.316 91.7996 160.168C72.2899 144.904 55.1064 126.881 40.7897 106.666C44.4608 107.001 48.1481 107.123 51.8332 107.032C64.2977 122.54 78.5631 136.51 94.3286 148.648C94.6053 148.859 94.9318 148.996 95.2766 149.045C95.6214 149.093 95.9729 149.053 96.2974 148.926C111.174 142.993 125.039 134.786 137.398 124.6C139.085 125.193 140.788 125.776 142.552 126.305ZM146.672 110.86C132.133 125.377 114.873 136.885 95.8813 144.725C76.363 129.461 59.1736 111.434 44.8552 91.2122C49.2729 91.6211 53.7132 91.7289 58.1455 91.535C70.0362 105.952 83.5137 118.984 98.323 130.383C98.5999 130.594 98.9265 130.73 99.2713 130.779C99.6161 130.827 99.9675 130.786 100.292 130.659C114.219 125.114 127.26 117.562 139.002 108.243C141.59 109.213 144.157 110.1 146.672 110.86ZM99.8757 126.458C80.3658 111.186 63.1777 93.1619 48.8496 72.9492C65.9961 74.2926 83.2224 71.686 99.2039 65.3298C116.284 78.2122 133.98 87.5811 150.658 92.5965C136.118 107.108 118.862 118.614 99.8757 126.458Z"
				fill="#C7C7C7"
			/>
			<path
				d="M109.477 92.6919C109.507 92.3354 109.443 91.9772 109.29 91.6535C109.138 91.3299 108.902 91.0523 108.608 90.849C102.074 86.3203 95.7928 81.437 89.793 76.2211C89.5366 76.0001 89.2293 75.8463 88.8987 75.7737C88.5682 75.701 88.2247 75.7118 87.8993 75.805C79.4839 78.2832 70.8035 79.7508 62.0412 80.1769C61.6633 80.1986 61.2988 80.3247 60.9884 80.5414C60.678 80.758 60.4339 81.0566 60.2832 81.4038C60.1325 81.7511 60.0812 82.1333 60.135 82.508C60.1888 82.8827 60.3456 83.2351 60.588 83.5259C66.4578 90.3792 72.6769 96.9254 79.2204 103.139C79.4603 103.366 79.7521 103.532 80.0704 103.621C80.3887 103.71 80.724 103.72 81.0471 103.65C90.4454 101.557 99.5867 98.443 108.308 94.3623C108.632 94.2119 108.911 93.9784 109.117 93.6854C109.322 93.3925 109.446 93.0484 109.477 92.6919ZM81.2298 99.4467C76.0587 94.495 71.0966 89.3298 66.3563 83.9643C73.6686 83.3303 80.9043 82.0044 87.9663 80.0044C92.9222 84.2675 98.0622 88.3117 103.372 92.1256C96.2306 95.2404 88.8201 97.6911 81.2298 99.4467Z"
				fill="#C7C7C7"
			/>
			<path
				d="M85.784 83.2965C85.0046 84.7213 84.2313 86.0954 83.454 87.502C80.2834 86.9353 77.1397 86.2276 74.0322 85.381C73.7722 85.2997 73.4985 85.2715 73.2274 85.2982C72.9563 85.3248 72.6934 85.4058 72.4542 85.5362C72.2151 85.6667 72.0047 85.8439 71.8355 86.0574C71.6663 86.2709 71.5418 86.5163 71.4694 86.7789C71.3971 87.0415 71.3783 87.316 71.4142 87.586C71.4502 87.856 71.5402 88.1161 71.6787 88.3506C71.8173 88.5851 72.0017 88.7893 72.2208 88.9511C72.44 89.1129 72.6895 89.2289 72.9544 89.2922C75.7351 90.0594 78.5543 90.6825 81.3857 91.2346C80.8377 92.219 80.2836 93.2338 79.7356 94.2101C79.5657 94.5195 79.479 94.8677 79.4839 95.2206C79.4887 95.5736 79.585 95.9192 79.7633 96.2239C79.9416 96.5285 80.1958 96.7817 80.5011 96.9588C80.8065 97.1359 81.1525 97.2308 81.5055 97.2343C83.866 97.005 84.3267 93.6296 85.6135 91.9815C88.9625 92.495 92.3257 92.903 95.697 93.1019C96.2241 93.1018 96.7305 92.8966 97.1091 92.5297C97.4876 92.1628 97.7086 91.6631 97.7252 91.1362C97.7418 90.6093 97.5528 90.0966 97.1981 89.7066C96.8434 89.3166 96.3509 89.0799 95.8248 89.0466C93.1127 88.861 90.4086 88.5726 87.7183 88.1819C88.516 86.4689 90.9353 83.9501 88.5383 82.4887C88.0659 82.2306 87.5104 82.1707 86.9939 82.3222C86.4773 82.4737 86.0421 82.8242 85.784 83.2965ZM96.9615 79.6715C97.1549 80.1737 97.5396 80.5786 98.0313 80.7974C98.5229 81.0162 99.0812 81.031 99.5838 80.8386C101.747 80.0068 103.89 79.1216 106.01 78.1838C106.254 78.0758 106.474 77.9209 106.658 77.7278C106.842 77.5348 106.986 77.3073 107.082 77.0586C107.178 76.8098 107.224 76.5445 107.218 76.2779C107.212 76.0112 107.153 75.7485 107.045 75.5046C106.937 75.2607 106.782 75.0405 106.589 74.8565C106.396 74.6724 106.168 74.5283 105.92 74.4321C105.671 74.336 105.406 74.2898 105.139 74.2962C104.872 74.3026 104.61 74.3615 104.366 74.4694C102.287 75.3909 100.189 76.2596 98.1285 77.0492C97.626 77.2422 97.2208 77.6269 97.0019 78.1186C96.783 78.6104 96.7685 79.169 96.9615 79.6715ZM103.791 84.7802C105.484 87.7232 109.052 84.2119 111.277 83.5482C111.758 83.3096 112.125 82.8901 112.297 82.3815C112.47 81.8729 112.434 81.3167 112.197 80.8347C111.96 80.3527 111.542 79.9842 111.034 79.8099C110.526 79.6356 109.969 79.6698 109.487 79.9049C107.629 81.2607 102.689 81.6647 103.791 84.7802ZM110.605 89.4606C112.083 91.9571 114.725 89.4403 116.523 88.661C116.996 88.4046 117.348 87.9709 117.502 87.4552C117.655 86.9395 117.597 86.384 117.341 85.9107C115.854 83.4711 113.27 86.0082 111.488 86.7287C111.25 86.8501 111.039 87.017 110.866 87.22C110.694 87.423 110.562 87.6581 110.48 87.9118C110.398 88.1655 110.367 88.4328 110.389 88.6986C110.41 88.9644 110.483 89.2233 110.605 89.4606ZM115.785 97.7275C115.534 97.2516 115.104 96.8947 114.591 96.7352C114.077 96.5757 113.521 96.6268 113.045 96.8771C105.578 100.834 97.7563 104.082 89.683 106.579C89.4247 106.654 89.1838 106.78 88.9744 106.949C88.7651 107.118 88.5914 107.327 88.4635 107.563C88.3357 107.8 88.2561 108.06 88.2295 108.327C88.2029 108.595 88.2299 108.866 88.3087 109.123C88.3875 109.38 88.5167 109.619 88.6888 109.826C88.8608 110.033 89.0722 110.203 89.3108 110.328C89.5494 110.452 89.8103 110.528 90.0784 110.551C90.3465 110.573 90.6164 110.542 90.8724 110.46C99.188 107.888 107.244 104.544 114.936 100.47C115.412 100.218 115.769 99.7885 115.928 99.2743C116.087 98.76 116.036 98.2037 115.785 97.7275ZM116.365 104.466C110.365 107.838 104.125 110.763 97.6962 113.22C97.1929 113.411 96.7861 113.794 96.5653 114.285C96.3446 114.776 96.3279 115.335 96.519 115.838C96.7101 116.342 97.0933 116.748 97.5843 116.969C98.0753 117.19 98.634 117.207 99.1373 117.016C105.753 114.487 112.174 111.476 118.348 108.006C118.812 107.74 119.152 107.301 119.294 106.786C119.437 106.271 119.37 105.72 119.109 105.254C118.848 104.787 118.413 104.443 117.899 104.295C117.386 104.147 116.834 104.21 116.365 104.466Z"
				fill="#C7C7C7"
			/>
		</svg>
	);
}

export function IncQuantityIcon(props: Props) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00065 14.6673C11.6673 14.6673 14.6673 11.6673 14.6673 8.00065C14.6673 4.33398 11.6673 1.33398 8.00065 1.33398C4.33398 1.33398 1.33398 4.33398 1.33398 8.00065C1.33398 11.6673 4.33398 14.6673 8.00065 14.6673Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.33398 8H10.6673"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8 10.6673V5.33398"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}
export function DecQuantityIcon(props: Props) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00065 14.6673C11.6673 14.6673 14.6673 11.6673 14.6673 8.00065C14.6673 4.33398 11.6673 1.33398 8.00065 1.33398C4.33398 1.33398 1.33398 4.33398 1.33398 8.00065C1.33398 11.6673 4.33398 14.6673 8.00065 14.6673Z"
				stroke="#ACACAC"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.33398 8H10.6673"
				stroke="#ACACAC"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function LogoutIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.5312 12.1837L16.6646 10.0503L14.5312 7.91699"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8.13281 10.0498H16.6078"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.79948 16.6663C6.11615 16.6663 3.13281 14.1663 3.13281 9.99967C3.13281 5.83301 6.11615 3.33301 9.79948 3.33301"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function OrderCartIcon(props: Props) {
	return (
		<svg
			width="23"
			height="20"
			viewBox="0 0 23 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.66667 1.66667H3.11667C4.01667 1.66667 4.725 2.44167 4.65 3.33333L3.95833 11.6333C3.84167 12.9917 4.91666 14.1583 6.28333 14.1583H15.1583C16.3583 14.1583 17.4083 13.175 17.5 11.9833L17.95 5.73334C18.05 4.35 17 3.225 15.6083 3.225H4.85001"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M13.5417 18.3333C14.117 18.3333 14.5833 17.867 14.5833 17.2917C14.5833 16.7164 14.117 16.25 13.5417 16.25C12.9664 16.25 12.5 16.7164 12.5 17.2917C12.5 17.867 12.9664 18.3333 13.5417 18.3333Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.875 18.3333C7.4503 18.3333 7.91667 17.867 7.91667 17.2917C7.91667 16.7164 7.4503 16.25 6.875 16.25C6.2997 16.25 5.83333 16.7164 5.83333 17.2917C5.83333 17.867 6.2997 18.3333 6.875 18.3333Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M7.5 6.66667H17.5"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function MenuIcon(props: Props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M3 7H12" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" />
			<path d="M3 12H21" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" />
			<path d="M3 17H16" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" />
		</svg>
	);
}

export function ShowMoreIcon(props: Props) {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx="20" cy="20" r="20" fill="#F1F1F1" />
			<path
				d="M18.334 25.8333C18.334 26.75 19.084 27.5 20.0007 27.5C20.9173 27.5 21.6673 26.75 21.6673 25.8333C21.6673 24.9167 20.9173 24.1667 20.0007 24.1667C19.084 24.1667 18.334 24.9167 18.334 25.8333Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
			/>
			<path
				d="M18.334 14.1663C18.334 15.083 19.084 15.833 20.0007 15.833C20.9173 15.833 21.6673 15.083 21.6673 14.1663C21.6673 13.2497 20.9173 12.4997 20.0007 12.4997C19.084 12.4997 18.334 13.2497 18.334 14.1663Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
			/>
			<path
				d="M18.334 20.0003C18.334 20.917 19.084 21.667 20.0007 21.667C20.9173 21.667 21.6673 20.917 21.6673 20.0003C21.6673 19.0837 20.9173 18.3337 20.0007 18.3337C19.084 18.3337 18.334 19.0837 18.334 20.0003Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
			/>
		</svg>
	);
}

export function EditOrder(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.66602 1.66699H3.11602C4.01602 1.66699 4.72435 2.44199 4.64935 3.33366L3.95768 11.6337C3.84102 12.992 4.91601 14.1587 6.28268 14.1587H15.1577C16.3577 14.1587 17.4077 13.1753 17.4993 11.9837L17.9493 5.73366"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5 4H11"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M13.5417 18.3333C14.117 18.3333 14.5833 17.867 14.5833 17.2917C14.5833 16.7164 14.117 16.25 13.5417 16.25C12.9664 16.25 12.5 16.7164 12.5 17.2917C12.5 17.867 12.9664 18.3333 13.5417 18.3333Z"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.87565 18.3333C7.45095 18.3333 7.91732 17.867 7.91732 17.2917C7.91732 16.7164 7.45095 16.25 6.87565 16.25C6.30035 16.25 5.83398 16.7164 5.83398 17.2917C5.83398 17.867 6.30035 18.3333 6.87565 18.3333Z"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.8604 1.40579L13.3535 3.91271C13.2543 4.01185 13.1623 4.19597 13.141 4.33052L13.0065 5.28655C12.9569 5.63355 13.1977 5.87434 13.5447 5.82477L14.5007 5.69021C14.6353 5.66897 14.8265 5.57689 14.9185 5.47775L17.4254 2.97085C17.8574 2.53887 18.0628 2.03607 17.4254 1.39872C16.7952 0.768451 16.2924 0.973805 15.8604 1.40579Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.5 1.7666C15.7125 2.53142 16.3073 3.12628 17.0721 3.33873"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ProductIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M6.99807 5.41602H12.9981C15.8314 5.41602 16.1147 6.74101 16.3064 8.35768L17.0564 14.6077C17.2981 16.6577 16.6647 18.3327 13.7481 18.3327H6.2564C3.3314 18.3327 2.69807 16.6577 2.94807 14.6077L3.69807 8.35768C3.88141 6.74101 4.16473 5.41602 6.99807 5.41602Z"
				stroke="#7D7D7D"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M6.66797 6.66602V3.74935C6.66797 2.49935 7.5013 1.66602 8.7513 1.66602H11.2513C12.5013 1.66602 13.3346 2.49935 13.3346 3.74935V6.66602"
				stroke="#7D7D7D"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M17.0096 14.1914H6.66797"
				stroke="#7D7D7D"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function UploadIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
				fill={props?.fill || '#E6AB00'}
				{...props}
			/>
			<path
				d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
				fill={props?.fill || '#E6AB00'}
				{...props}
			/>
		</svg>
	);
}

export function Cross(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path
				d="M5.39844 12.6004L12.5984 5.40039"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.5984 12.6004L5.39844 5.40039"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function SlideCancelIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M11.6797 14.62L14.2397 12.06L11.6797 9.5"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M4 12.0601H14.17"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function WarningIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M18.134 13.2667L12.8007 3.66675C12.084 2.37508 11.0924 1.66675 10.0007 1.66675C8.90905 1.66675 7.91738 2.37508 7.20071 3.66675L1.86738 13.2667C1.19238 14.4917 1.11738 15.6667 1.65905 16.5917C2.20071 17.5167 3.26738 18.0251 4.66738 18.0251H15.334C16.734 18.0251 17.8007 17.5167 18.3424 16.5917C18.884 15.6667 18.809 14.4834 18.134 13.2667ZM9.37571 7.50008C9.37571 7.15841 9.65905 6.87508 10.0007 6.87508C10.3424 6.87508 10.6257 7.15841 10.6257 7.50008V11.6667C10.6257 12.0084 10.3424 12.2917 10.0007 12.2917C9.65905 12.2917 9.37571 12.0084 9.37571 11.6667V7.50008ZM10.5924 14.7584C10.5507 14.7917 10.509 14.8251 10.4674 14.8584C10.4174 14.8917 10.3674 14.9167 10.3174 14.9334C10.2674 14.9584 10.2174 14.9751 10.159 14.9834C10.109 14.9917 10.0507 15.0001 10.0007 15.0001C9.95071 15.0001 9.89238 14.9917 9.83405 14.9834C9.78405 14.9751 9.73405 14.9584 9.68405 14.9334C9.63405 14.9167 9.58405 14.8917 9.53405 14.8584C9.49238 14.8251 9.45071 14.7917 9.40905 14.7584C9.25905 14.6001 9.16738 14.3834 9.16738 14.1667C9.16738 13.9501 9.25905 13.7334 9.40905 13.5751C9.45071 13.5417 9.49238 13.5084 9.53405 13.4751C9.58405 13.4417 9.63405 13.4167 9.68405 13.4001C9.73405 13.3751 9.78405 13.3584 9.83405 13.3501C9.94238 13.3251 10.059 13.3251 10.159 13.3501C10.2174 13.3584 10.2674 13.3751 10.3174 13.4001C10.3674 13.4167 10.4174 13.4417 10.4674 13.4751C10.509 13.5084 10.5507 13.5417 10.5924 13.5751C10.7424 13.7334 10.834 13.9501 10.834 14.1667C10.834 14.3834 10.7424 14.6001 10.5924 14.7584Z"
				fill="#F26184"
			/>
		</svg>
	);
}

export function CommentIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M15.3913 14.025L15.7163 16.6583C15.7997 17.35 15.058 17.8333 14.4663 17.475L11.583 15.7583C11.383 15.6417 11.333 15.3917 11.4413 15.1917C11.858 14.425 12.083 13.5583 12.083 12.6917C12.083 9.64166 9.46633 7.15832 6.24967 7.15832C5.59133 7.15832 4.94967 7.25832 4.34967 7.45832C4.04133 7.55832 3.74133 7.27499 3.81633 6.95832C4.57467 3.92499 7.49133 1.66666 10.9747 1.66666C15.0413 1.66666 18.333 4.74166 18.333 8.53332C18.333 10.7833 17.1747 12.775 15.3913 14.025Z"
				fill="#FFBE00"
			/>
			<path
				d="M10.8346 12.6917C10.8346 13.6833 10.468 14.6 9.8513 15.325C9.0263 16.325 7.71797 16.9667 6.2513 16.9667L4.0763 18.2583C3.70964 18.4833 3.24297 18.175 3.29297 17.75L3.5013 16.1083C2.38464 15.3333 1.66797 14.0917 1.66797 12.6917C1.66797 11.225 2.4513 9.93333 3.6513 9.16666C4.39297 8.68333 5.28464 8.40833 6.2513 8.40833C8.78464 8.40833 10.8346 10.325 10.8346 12.6917Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function TickSVG(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
			<circle cx="7.5" cy="7.5" r="7.5" fill="#FFBE00" />
			<path
				d="M4.5 7.5L6.49765 9.5L10.5 5.5"
				stroke="white"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function TickSVGBlack(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
			<circle cx="7.5" cy="7.5" r="7.5" fill="#5C5C5C" />
			<path
				d="M4.5 7.5L6.49765 9.5L10.5 5.5"
				stroke="white"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function SaveReviewIcon({ stroke = '#5C5C5C' }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M14.0156 1.66675H5.98229C4.20729 1.66675 2.76562 3.11675 2.76562 4.88341V16.6251C2.76562 18.1251 3.84063 18.7584 5.15729 18.0334L9.22396 15.7751C9.65729 15.5334 10.3573 15.5334 10.7823 15.7751L14.849 18.0334C16.1656 18.7667 17.2406 18.1334 17.2406 16.6251V4.88341C17.2323 3.11675 15.7906 1.66675 14.0156 1.66675Z"
				stroke={stroke}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M7.99219 9.16659L9.24219 10.4166L12.5755 7.08325"
				stroke={stroke}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function MarketplaceIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M2.50781 9.34998V13.0916C2.50781 16.8333 4.00781 18.3333 7.74948 18.3333H12.2411C15.9828 18.3333 17.4828 16.8333 17.4828 13.0916V9.34998"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M10.0017 9.99996C11.5267 9.99996 12.6517 8.75829 12.5017 7.23329L11.9517 1.66663H8.06003L7.5017 7.23329C7.3517 8.75829 8.4767 9.99996 10.0017 9.99996Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M15.2596 9.99996C16.943 9.99996 18.1763 8.63329 18.0096 6.95829L17.7763 4.66663C17.4763 2.49996 16.643 1.66663 14.4596 1.66663H11.918L12.5013 7.50829C12.643 8.88329 13.8846 9.99996 15.2596 9.99996Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M4.69868 9.99996C6.07368 9.99996 7.31535 8.88329 7.44868 7.50829L7.63202 5.66663L8.03202 1.66663H5.49035C3.30702 1.66663 2.47368 2.49996 2.17368 4.66663L1.94868 6.95829C1.78201 8.63329 3.01535 9.99996 4.69868 9.99996Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M10.0013 14.1666C8.60964 14.1666 7.91797 14.8583 7.91797 16.25V18.3333H12.0846V16.25C12.0846 14.8583 11.393 14.1666 10.0013 14.1666Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function LeftArrow(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M12.5005 16.6L7.06719 11.1667C6.42552 10.525 6.42552 9.47502 7.06719 8.83336L12.5005 3.40002"
				stroke="#ACACAC"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function RightArrow(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M7.42578 16.5984L12.8591 11.1651C13.5008 10.5234 13.5008 9.47344 12.8591 8.83177L7.42578 3.39844"
				stroke="#ACACAC"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function PlusIcon({ stroke = '#FFBE00', ...props }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<path
				d="M2.5 8H13.5"
				stroke={stroke}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8 2.5V13.5"
				stroke={stroke}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function MinusIcon({ stroke = '#FFBE00', ...props }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<path
				d="M2.5 8H13.5"
				stroke={stroke}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function CartIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M13.5404 18.7502C14.3458 18.7502 14.9987 18.0972 14.9987 17.2918C14.9987 16.4864 14.3458 15.8335 13.5404 15.8335C12.7349 15.8335 12.082 16.4864 12.082 17.2918C12.082 18.0972 12.7349 18.7502 13.5404 18.7502Z"
				fill="white"
				{...props}
			/>
			<path
				d="M6.8763 18.7502C7.68172 18.7502 8.33464 18.0972 8.33464 17.2918C8.33464 16.4864 7.68172 15.8335 6.8763 15.8335C6.07089 15.8335 5.41797 16.4864 5.41797 17.2918C5.41797 18.0972 6.07089 18.7502 6.8763 18.7502Z"
				fill="white"
				{...props}
			/>
			<path
				d="M4.03464 3.28317L3.86797 5.32484C3.83464 5.7165 4.14297 6.0415 4.53464 6.0415H17.293C17.643 6.0415 17.9346 5.77484 17.9596 5.42484C18.068 3.94984 16.943 2.74984 15.468 2.74984H5.2263C5.14297 2.38317 4.9763 2.03317 4.71797 1.7415C4.3013 1.29984 3.71797 1.0415 3.11797 1.0415H1.66797C1.3263 1.0415 1.04297 1.32484 1.04297 1.6665C1.04297 2.00817 1.3263 2.2915 1.66797 2.2915H3.11797C3.3763 2.2915 3.61797 2.39984 3.79297 2.58317C3.96797 2.77484 4.0513 3.02484 4.03464 3.28317Z"
				fill="white"
				{...props}
			/>
			<path
				d="M17.0904 7.2915H4.30708C3.95708 7.2915 3.67374 7.55817 3.64041 7.89984L3.34041 11.5248C3.22374 12.9498 4.34041 14.1665 5.76541 14.1665H15.0321C16.2821 14.1665 17.3821 13.1415 17.4737 11.8915L17.7487 7.99984C17.7821 7.6165 17.4821 7.2915 17.0904 7.2915Z"
				fill="white"
				{...props}
			/>
		</svg>
	);
}

export const CameraIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path
				d="M13.9988 3.99984C13.4905 3.99984 13.0238 3.70817 12.7905 3.25817L12.1905 2.04984C11.8072 1.2915 10.8072 0.666504 9.95717 0.666504H8.04884C7.1905 0.666504 6.1905 1.2915 5.80717 2.04984L5.20717 3.25817C4.97384 3.70817 4.50717 3.99984 3.99884 3.99984C2.1905 3.99984 0.757171 5.52484 0.873838 7.32484L1.30717 14.2082C1.40717 15.9248 2.33217 17.3332 4.63217 17.3332H13.3655C15.6655 17.3332 16.5822 15.9248 16.6905 14.2082L17.1238 7.32484C17.2405 5.52484 15.8072 3.99984 13.9988 3.99984ZM7.74884 5.0415H10.2488C10.5905 5.0415 10.8738 5.32484 10.8738 5.6665C10.8738 6.00817 10.5905 6.2915 10.2488 6.2915H7.74884C7.40717 6.2915 7.12384 6.00817 7.12384 5.6665C7.12384 5.32484 7.40717 5.0415 7.74884 5.0415ZM8.99884 14.0998C7.44884 14.0998 6.18217 12.8415 6.18217 11.2832C6.18217 9.72484 7.4405 8.4665 8.99884 8.4665C10.5572 8.4665 11.8155 9.72484 11.8155 11.2832C11.8155 12.8415 10.5488 14.0998 8.99884 14.0998Z"
				fill="#ffff"
			/>
		</svg>
	);
};

export const PermissionIcon = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M9.9987 9.99984C12.2999 9.99984 14.1654 8.13436 14.1654 5.83317C14.1654 3.53198 12.2999 1.6665 9.9987 1.6665C7.69751 1.6665 5.83203 3.53198 5.83203 5.83317C5.83203 8.13436 7.69751 9.99984 9.9987 9.99984Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M2.83984 18.3333C2.83984 15.1083 6.04817 12.5 9.99817 12.5C10.7982 12.5 11.5732 12.6083 12.2982 12.8083"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3346 14.9998C18.3346 15.6248 18.1596 16.2165 17.8513 16.7165C17.6763 17.0165 17.4513 17.2832 17.193 17.4998C16.6096 18.0248 15.843 18.3332 15.0013 18.3332C13.7846 18.3332 12.7263 17.6832 12.1513 16.7165C11.843 16.2165 11.668 15.6248 11.668 14.9998C11.668 13.9498 12.1513 13.0082 12.918 12.3998C13.493 11.9415 14.218 11.6665 15.0013 11.6665C16.843 11.6665 18.3346 13.1582 18.3346 14.9998Z"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M13.7031 14.9998L14.5281 15.8247L16.3031 14.1831"
				stroke="#5C5C5C"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
};

export const ATTHERATEICON = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M9.72476 18.9394C8.43069 18.9394 7.24559 18.7283 6.16947 18.306C5.09335 17.8974 4.16707 17.298 3.39063 16.5079C2.6278 15.7315 2.03526 14.8052 1.61298 13.7291C1.20433 12.6393 1 11.4134 1 10.0512C1 8.70264 1.21114 7.47668 1.63341 6.37331C2.06931 5.25632 2.6891 4.29599 3.49279 3.4923C4.29647 2.68862 5.25 2.07563 6.35337 1.65336C7.47035 1.21746 8.69631 0.999512 10.0312 0.999512C11.625 0.999512 13.0212 1.31962 14.22 1.95985C15.4187 2.58645 16.345 3.46506 16.9988 4.59567C17.6663 5.72628 18 7.0544 18 8.58004C18 9.76514 17.8365 10.7936 17.5096 11.6654C17.1827 12.5236 16.7264 13.191 16.1406 13.6678C15.5549 14.1445 14.867 14.3829 14.0769 14.3829C13.2596 14.3829 12.633 14.1514 12.1971 13.6882C11.7612 13.2251 11.5501 12.5848 11.5637 11.7675L12.0745 11.7471C11.734 12.6053 11.2504 13.2591 10.6238 13.7086C9.9972 14.1582 9.32973 14.3829 8.62139 14.3829C7.54527 14.3829 6.70753 14.0492 6.10817 13.3817C5.52244 12.7143 5.22957 11.7948 5.22957 10.6233C5.22957 9.62892 5.42027 8.7435 5.80168 7.96706C6.18309 7.177 6.70753 6.5572 7.375 6.10769C8.04247 5.65817 8.79848 5.43341 9.64303 5.43341C10.365 5.43341 10.9575 5.6173 11.4207 5.98509C11.8974 6.35288 12.2107 6.87732 12.3606 7.55841H12.0745L12.2993 6.31201C12.381 5.80801 12.6807 5.556 13.1983 5.556C13.4571 5.556 13.6478 5.63092 13.7704 5.78076C13.9066 5.9306 13.9475 6.14855 13.893 6.43461L13.137 10.7459C13.0962 10.9502 13.0621 11.1409 13.0349 11.318C13.0212 11.4815 13.0144 11.6381 13.0144 11.788C13.0144 12.2239 13.1098 12.5508 13.3005 12.7687C13.5048 12.9867 13.7977 13.0957 14.1791 13.0957C14.6695 13.0957 15.0986 12.9118 15.4663 12.544C15.8341 12.1626 16.1202 11.6313 16.3245 10.9502C16.5288 10.2691 16.631 9.47908 16.631 8.58004C16.631 7.29959 16.3586 6.19623 15.8137 5.26995C15.2688 4.33004 14.4992 3.60809 13.5048 3.10408C12.524 2.60007 11.3594 2.34807 10.0108 2.34807C8.51242 2.34807 7.19792 2.66818 6.06731 3.30841C4.95032 3.93501 4.07853 4.82724 3.45192 5.98509C2.82532 7.14294 2.51202 8.49831 2.51202 10.0512C2.51202 11.6177 2.80489 12.9663 3.39063 14.0969C3.98998 15.2275 4.82772 16.0925 5.90385 16.6918C6.99359 17.2912 8.26723 17.5909 9.72476 17.5909C10.6783 17.5909 11.5433 17.4683 12.3197 17.2231C13.0962 16.9779 13.7772 16.6237 14.363 16.1606C14.5673 15.9971 14.758 15.929 14.9351 15.9562C15.1258 15.9971 15.2688 16.0925 15.3642 16.2423C15.4732 16.3921 15.514 16.5556 15.4868 16.7327C15.4595 16.9234 15.3438 17.1005 15.1394 17.2639C14.5128 17.7816 13.7364 18.1902 12.8101 18.4899C11.8974 18.7896 10.869 18.9394 9.72476 18.9394ZM8.88702 13.0139C9.44551 13.0139 9.94271 12.8437 10.3786 12.5031C10.8281 12.149 11.1755 11.6722 11.4207 11.0728C11.6795 10.4598 11.8089 9.76514 11.8089 8.9887C11.8089 8.26674 11.6454 7.72868 11.3185 7.37451C11.0052 7.00672 10.5216 6.82283 9.86779 6.82283C9.30929 6.82283 8.80529 6.98629 8.35577 7.31321C7.90625 7.64014 7.55208 8.08966 7.29327 8.66177C7.04808 9.22027 6.92548 9.8673 6.92548 10.6029C6.92548 11.3793 7.09575 11.9787 7.4363 12.401C7.77684 12.8096 8.26042 13.0139 8.88702 13.0139Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
};

export const LockIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68" fill="none">
			<path
				d="M17 28.3337V22.667C17 13.2887 19.8333 5.66699 34 5.66699C48.1667 5.66699 51 13.2887 51 22.667V28.3337"
				fill="#FFFDF5"
			/>
			<path
				d="M17 28.3337V22.667C17 13.2887 19.8333 5.66699 34 5.66699C48.1667 5.66699 51 13.2887 51 22.667V28.3337"
				stroke="#FFBE00"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M48.168 62.333H19.8346C8.5013 62.333 5.66797 59.4997 5.66797 48.1663V42.4997C5.66797 31.1663 8.5013 28.333 19.8346 28.333H48.168C59.5013 28.333 62.3346 31.1663 62.3346 42.4997V48.1663C62.3346 59.4997 59.5013 62.333 48.168 62.333Z"
				fill="#FFFDF5"
				stroke="#FFBE00"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M34.0013 52.4167C37.9133 52.4167 41.0846 49.2454 41.0846 45.3333C41.0846 41.4213 37.9133 38.25 34.0013 38.25C30.0893 38.25 26.918 41.4213 26.918 45.3333C26.918 49.2454 30.0893 52.4167 34.0013 52.4167Z"
				stroke="#FFBE00"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const LockIconSmall = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M5 8.33366V6.66699C5 3.90866 5.83333 1.66699 10 1.66699C14.1667 1.66699 15 3.90866 15 6.66699V8.33366"
				stroke="#acacac"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M14.168 18.333H5.83464C2.5013 18.333 1.66797 17.4997 1.66797 14.1663V12.4997C1.66797 9.16634 2.5013 8.33301 5.83464 8.33301H14.168C17.5013 8.33301 18.3346 9.16634 18.3346 12.4997V14.1663C18.3346 17.4997 17.5013 18.333 14.168 18.333Z"
				stroke="#acacac"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M10.0013 15.4167C11.1519 15.4167 12.0846 14.4839 12.0846 13.3333C12.0846 12.1827 11.1519 11.25 10.0013 11.25C8.85071 11.25 7.91797 12.1827 7.91797 13.3333C7.91797 14.4839 8.85071 15.4167 10.0013 15.4167Z"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
};

export const FallBackSVG = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
			<circle cx="30" cy="30" r="30" fill="#F2F2F2" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M30.3179 23.2793L34.5 16.2505L45 33.8976H35.8935C35.9637 33.4172 36 32.9262 36 32.427C36 28.4469 33.6922 24.992 30.3179 23.2793ZM30.3179 23.2793C28.8747 22.5467 27.2363 22.1328 25.5 22.1328C19.704 22.1328 15 26.7446 15 32.427C15 38.1093 19.704 42.7211 25.5 42.7211C30.7868 42.7211 35.165 38.8841 35.8935 33.8976H24L30.3179 23.2793Z"
				fill="#D5D5D5"
			/>
		</svg>
	);
};

export const SettingsIcon2 = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
				stroke={props?.stroke}
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M1.66797 10.7329V9.26621C1.66797 8.39954 2.3763 7.68287 3.2513 7.68287C4.75964 7.68287 5.3763 6.61621 4.61797 5.30787C4.18464 4.55787 4.44297 3.58287 5.2013 3.14954L6.64297 2.32454C7.3013 1.93287 8.1513 2.16621 8.54297 2.82454L8.63463 2.98287C9.38463 4.29121 10.618 4.29121 11.3763 2.98287L11.468 2.82454C11.8596 2.16621 12.7096 1.93287 13.368 2.32454L14.8096 3.14954C15.568 3.58287 15.8263 4.55787 15.393 5.30787C14.6346 6.61621 15.2513 7.68287 16.7596 7.68287C17.6263 7.68287 18.343 8.39121 18.343 9.26621V10.7329C18.343 11.5995 17.6346 12.3162 16.7596 12.3162C15.2513 12.3162 14.6346 13.3829 15.393 14.6912C15.8263 15.4495 15.568 16.4162 14.8096 16.8495L13.368 17.6745C12.7096 18.0662 11.8596 17.8329 11.468 17.1745L11.3763 17.0162C10.6263 15.7079 9.39297 15.7079 8.63463 17.0162L8.54297 17.1745C8.1513 17.8329 7.3013 18.0662 6.64297 17.6745L5.2013 16.8495C4.44297 16.4162 4.18464 15.4412 4.61797 14.6912C5.3763 13.3829 4.75964 12.3162 3.2513 12.3162C2.3763 12.3162 1.66797 11.5995 1.66797 10.7329Z"
				stroke={props?.stroke}
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const SiteIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
			<path
				d="M7.58203 6.41712L12.3654 1.63379"
				stroke="#7D7D7D"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.8352 3.96699V1.16699H10.0352"
				stroke="#7D7D7D"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.41797 1.16699H5.2513C2.33464 1.16699 1.16797 2.33366 1.16797 5.25033V8.75033C1.16797 11.667 2.33464 12.8337 5.2513 12.8337H8.7513C11.668 12.8337 12.8346 11.667 12.8346 8.75033V7.58366"
				stroke="#7D7D7D"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const SecurityIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M19.5119 5.85L13.5719 2.42C12.6019 1.86 11.4019 1.86 10.4219 2.42L4.49187 5.85C3.52187 6.41 2.92188 7.45 2.92188 8.58V15.42C2.92188 16.54 3.52187 17.58 4.49187 18.15L10.4319 21.58C11.4019 22.14 12.6019 22.14 13.5819 21.58L19.5219 18.15C20.4919 17.59 21.0919 16.55 21.0919 15.42V8.58C21.0819 7.45 20.4819 6.42 19.5119 5.85ZM11.2519 7.75C11.2519 7.34 11.5919 7 12.0019 7C12.4119 7 12.7519 7.34 12.7519 7.75V13C12.7519 13.41 12.4119 13.75 12.0019 13.75C11.5919 13.75 11.2519 13.41 11.2519 13V7.75ZM12.9219 16.63C12.8719 16.75 12.8019 16.86 12.7119 16.96C12.5219 17.15 12.2719 17.25 12.0019 17.25C11.8719 17.25 11.7419 17.22 11.6219 17.17C11.4919 17.12 11.3919 17.05 11.2919 16.96C11.2019 16.86 11.1319 16.75 11.0719 16.63C11.0219 16.51 11.0019 16.38 11.0019 16.25C11.0019 15.99 11.1019 15.73 11.2919 15.54C11.3919 15.45 11.4919 15.38 11.6219 15.33C11.9919 15.17 12.4319 15.26 12.7119 15.54C12.8019 15.64 12.8719 15.74 12.9219 15.87C12.9719 15.99 13.0019 16.12 13.0019 16.25C13.0019 16.38 12.9719 16.51 12.9219 16.63Z"
				fill="#F26184"
			/>
		</svg>
	);
};

export const CopyClipBoardIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path
				d="M12 9.675V12.825C12 15.45 10.95 16.5 8.325 16.5H5.175C2.55 16.5 1.5 15.45 1.5 12.825V9.675C1.5 7.05 2.55 6 5.175 6H8.325C10.95 6 12 7.05 12 9.675Z"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16.5 5.175V8.325C16.5 10.95 15.45 12 12.825 12H12V9.675C12 7.05 10.95 6 8.325 6H6V5.175C6 2.55 7.05 1.5 9.675 1.5H12.825C15.45 1.5 16.5 2.55 16.5 5.175Z"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const CopyClipBoardSuccessIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path
				d="M16.5 8.325V5.175C16.5 2.55 15.45 1.5 12.825 1.5H9.675C7.05 1.5 6 2.55 6 5.175V6H8.325C10.95 6 12 7.05 12 9.675V12H12.825C15.45 12 16.5 10.95 16.5 8.325Z"
				stroke="#00C853"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12 12.825V9.675C12 7.05 10.95 6 8.325 6H5.175C2.55 6 1.5 7.05 1.5 9.675V12.825C1.5 15.45 2.55 16.5 5.175 16.5H8.325C10.95 16.5 12 15.45 12 12.825Z"
				fill="#00C853"
				stroke="#00C853"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M4.55859 11.2496L6.02109 12.7121L8.93859 9.78711"
				stroke="white"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const StatusAlertIcon = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<circle cx="9" cy="9" r="9" fill={props?.fill} fill-opacity="0.1" />
			<circle cx="9" cy="9" r="3" fill={props?.fill} />
		</svg>
	);
};

export const NoTools = (props: Props) => {
	return (
		<svg
			width="201"
			height="200"
			viewBox="0 0 201 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M138.914 35.9863C159.759 44.8938 159.413 73.5871 162.935 95.9658C166.03 115.634 170.637 137.717 157.242 152.441C144.365 166.596 122.535 161.02 103.391 161.419C83.2905 161.837 61.694 167.855 46.4471 154.746C28.0503 138.929 12.7843 113.331 20.8906 90.4862C28.6512 68.6154 68.3719 87.2084 89.4488 77.4757C109.793 68.0813 118.296 27.1761 138.914 35.9863Z"
				fill="#BCBCBC"
				fill-opacity="0.2"
			/>
			<path
				d="M51.813 110.847C51.3682 110.841 50.9316 110.967 50.5582 111.208C50.1848 111.45 49.8914 111.797 49.7153 112.205C49.5391 112.614 49.488 113.065 49.5684 113.503C49.6488 113.94 49.8571 114.344 50.167 114.663C50.4769 114.982 50.8745 115.202 51.3094 115.295C51.7444 115.388 52.1972 115.35 52.6106 115.186C53.0239 115.022 53.3793 114.739 53.6318 114.373C53.8843 114.006 54.0225 113.574 54.029 113.129C54.037 112.533 53.8083 111.958 53.3928 111.53C52.9774 111.102 52.4092 110.857 51.813 110.847ZM51.7639 114.22C51.5415 114.217 51.3251 114.148 51.142 114.022C50.9589 113.896 50.8173 113.718 50.7352 113.511C50.6531 113.305 50.6341 113.078 50.6807 112.861C50.7273 112.643 50.8373 112.444 50.9968 112.29C51.1563 112.135 51.3582 112.03 51.577 111.99C51.7957 111.95 52.0214 111.976 52.2257 112.064C52.4299 112.152 52.6034 112.298 52.7242 112.485C52.8451 112.672 52.9078 112.89 52.9046 113.113C52.9001 113.411 52.7774 113.695 52.5635 113.903C52.3496 114.11 52.062 114.225 51.7639 114.22ZM40.312 59.2563C40.6085 59.2607 40.8997 59.177 41.1486 59.0158C41.3975 58.8547 41.5931 58.6233 41.7105 58.3511C41.828 58.0788 41.862 57.7778 41.8084 57.4861C41.7548 57.1945 41.6159 56.9253 41.4093 56.7126C41.2027 56.4999 40.9377 56.3532 40.6477 56.2911C40.3578 56.2291 40.0559 56.2544 39.7803 56.3638C39.5047 56.4733 39.2678 56.6621 39.0995 56.9062C38.9312 57.1503 38.839 57.4389 38.8347 57.7354C38.8293 58.1329 38.9818 58.5162 39.2588 58.8014C39.5358 59.0865 39.9146 59.2502 40.312 59.2563ZM40.3448 57.0076C40.493 57.0098 40.6373 57.0559 40.7594 57.14C40.8814 57.2242 40.9758 57.3427 41.0305 57.4804C41.0853 57.6182 41.0979 57.7692 41.0669 57.9141C41.0359 58.0591 40.9625 58.1916 40.8562 58.295C40.7498 58.3983 40.6152 58.4677 40.4694 58.4945C40.3236 58.5213 40.1731 58.5043 40.0369 58.4455C39.9008 58.3868 39.7851 58.289 39.7045 58.1646C39.624 58.0401 39.5821 57.8945 39.5843 57.7463C39.5874 57.5476 39.6692 57.3582 39.8118 57.2197C39.9543 57.0812 40.146 57.0049 40.3448 57.0076ZM156.473 113.956C156.769 113.96 157.061 113.877 157.31 113.715C157.558 113.554 157.754 113.323 157.871 113.051C157.989 112.778 158.023 112.477 157.969 112.186C157.916 111.894 157.777 111.625 157.57 111.412C157.364 111.2 157.099 111.053 156.809 110.991C156.519 110.929 156.217 110.954 155.941 111.063C155.666 111.173 155.429 111.362 155.26 111.606C155.092 111.85 155 112.139 154.996 112.435C154.99 112.833 155.143 113.216 155.42 113.501C155.697 113.786 156.075 113.95 156.473 113.956ZM156.506 111.707C156.654 111.709 156.798 111.756 156.92 111.84C157.042 111.924 157.137 112.042 157.191 112.18C157.246 112.318 157.259 112.469 157.228 112.614C157.197 112.759 157.123 112.891 157.017 112.995C156.911 113.098 156.776 113.167 156.63 113.194C156.484 113.221 156.334 113.204 156.198 113.145C156.062 113.086 155.946 112.989 155.865 112.864C155.785 112.74 155.743 112.594 155.745 112.446C155.748 112.247 155.83 112.058 155.973 111.919C156.115 111.781 156.307 111.705 156.506 111.707Z"
				fill="#C7C7C7"
			/>
			<path
				d="M31.3936 101.263L32.5083 99.7975L31.8044 99.3987L31.0885 101.04H31.0653L30.3381 99.4099L29.6222 99.8207L30.7249 101.252V101.275L29 101.052V101.85L30.7362 101.627V101.651L29.6222 103.081L30.2901 103.504L31.0533 101.85H31.0765L31.7804 103.492L32.5196 103.07L31.3936 101.662V101.639L33.1643 101.85V101.052L31.3936 101.287V101.263ZM77.0066 52.2969L76.3649 53.1208L76.7502 53.3636L77.1895 52.4116H77.203L77.6078 53.3569L78.0336 53.114L77.3852 52.3036V52.2901L78.4047 52.4116V51.9521L77.3852 52.087V52.0735L78.0269 51.2294L77.6221 51L77.2098 51.9453H77.1963L76.778 51.0067L76.3649 51.2429L77.0006 52.0667V52.0802L76.0073 51.9521V52.4116L77.0066 52.2834V52.2969ZM146.716 70.9391V70.1572L144.979 70.3866V70.3641L146.073 68.9263L145.383 68.535L144.681 70.1452H144.657L143.945 68.5462L143.242 68.9488L144.324 70.3529V70.3754L142.632 70.1572V70.9391L144.335 70.721V70.7434L143.242 72.1468L143.898 72.5613L144.646 70.9391H144.668L145.359 72.5501L146.084 72.1355L144.979 70.7547V70.7322L146.716 70.9391ZM104.456 62.8639L105.399 61.624L104.804 61.2859L104.199 62.675H104.179L103.564 61.2956L102.958 61.6435L103.891 62.8542V62.8744L102.432 62.6855V63.3602L103.901 63.172V63.1915L102.958 64.4022L103.523 64.7598L104.169 63.3602H104.189L104.784 64.7493L105.409 64.3924L104.456 63.2013V63.1818L105.955 63.3602V62.6855L104.456 62.8841V62.8639Z"
				fill="#C7C7C7"
			/>
			<path
				d="M61.1602 138.333H136.517V144.251H61.1602V138.333ZM93.4631 145.296H104.408V156.241H93.4631V145.296ZM166.225 76.7123C166.229 74.6374 165.75 72.5901 164.827 70.7318C163.904 68.8736 162.562 67.2552 160.906 66.0043C159.251 64.7535 157.327 63.9044 155.288 63.524C153.248 63.1437 151.148 63.2425 149.153 63.8126C148.517 62.0833 147.426 60.5582 145.994 59.3989C144.562 58.2396 142.844 57.4893 141.02 57.2277C139.197 56.966 137.336 57.2026 135.636 57.9125C133.936 58.6224 132.46 59.7791 131.364 61.2599C131.383 58.6933 130.438 56.2129 128.715 54.3106C126.992 52.4082 124.617 51.2226 122.06 50.9889C119.504 50.7551 116.954 51.4901 114.914 53.0483C112.874 54.6065 111.495 56.8742 111.048 59.4018C109.885 57.7538 108.261 56.4859 106.38 55.7571C104.499 55.0284 102.445 54.8711 100.475 55.305C98.5056 55.739 96.7077 56.7449 95.3072 58.1966C93.9067 59.6483 92.966 61.4812 92.6031 63.4653C85.6105 57.5928 74.6108 63.9326 76.1598 73.0033C61.5056 84.9376 74.6398 108.286 92.4994 101.33C92.6603 103.509 93.5171 105.579 94.9434 107.234C96.3697 108.889 98.2901 110.042 100.421 110.523C102.553 111.004 104.782 110.788 106.781 109.906C108.78 109.024 110.443 107.523 111.524 105.624C117.646 111.262 128.688 108.852 132.008 101.335C140.793 112.957 159.076 104.121 155.534 89.8938C158.562 89.2649 161.28 87.6096 163.228 85.2077C165.176 82.8058 166.235 79.8048 166.225 76.7123Z"
				fill="white"
			/>
			<path
				d="M152.945 62.3399C152.038 62.3402 151.132 62.4236 150.24 62.589C149.439 61.0778 148.326 59.7543 146.974 58.7066C145.623 57.6589 144.063 56.9109 142.4 56.5124C140.737 56.1139 139.008 56.0741 137.329 56.3954C135.649 56.7168 134.057 57.3921 132.658 58.3763C131.921 56.0817 130.514 54.0604 128.618 52.5728C126.722 51.0852 124.424 50.1995 122.02 50.0299C119.616 49.8603 117.216 50.4145 115.13 51.6212C113.044 52.8278 111.367 54.6316 110.315 56.8C108.857 55.6255 107.146 54.806 105.317 54.4059C103.488 54.0059 101.591 54.0364 99.7758 54.495C97.9605 54.9535 96.2767 55.8276 94.8571 57.0483C93.4375 58.269 92.321 59.8029 91.5956 61.529C83.6176 57.3036 73.4869 64.1235 74.2778 73.1414C71.477 75.6395 69.5045 78.932 68.6232 82.58C67.7419 86.228 67.9937 90.058 69.3452 93.5591H64.4544C63.0083 93.5606 61.6217 94.1357 60.5992 95.1583C59.5766 96.1809 59.0014 97.5674 59 99.0136V140.831C59.0014 142.277 59.5766 143.663 60.5992 144.686C61.6217 145.709 63.0083 146.284 64.4544 146.285H91.7265V155.376H86.2721C85.7899 155.376 85.3274 155.567 84.9865 155.908C84.6455 156.249 84.454 156.712 84.454 157.194C84.454 157.676 84.6455 158.139 84.9865 158.48C85.3274 158.821 85.7899 159.012 86.2721 159.012H111.726C112.208 159.012 112.671 158.821 113.012 158.48C113.353 158.139 113.544 157.676 113.544 157.194C113.544 156.712 113.353 156.249 113.012 155.908C112.671 155.567 112.208 155.376 111.726 155.376H106.272V146.285H133.544C134.99 146.284 136.376 145.709 137.399 144.686C138.422 143.663 138.997 142.277 138.998 140.831V108.952C141.408 109.534 143.923 109.521 146.326 108.912C148.729 108.304 150.947 107.118 152.789 105.459C154.63 103.799 156.039 101.716 156.894 99.3887C157.748 97.0617 158.022 94.5615 157.692 92.1046C173.806 86.5029 170.117 62.6035 152.945 62.3399ZM102.637 155.376H95.3646V146.285H102.637V155.376ZM135.364 140.831C135.363 141.313 135.172 141.775 134.831 142.116C134.49 142.457 134.028 142.648 133.546 142.649H64.4562C63.9742 142.648 63.512 142.457 63.1712 142.116C62.8303 141.775 62.6386 141.313 62.6381 140.831V99.0136C62.6386 98.5315 62.8303 98.0693 63.1712 97.7285C63.512 97.3876 63.9742 97.1959 64.4562 97.1954H71.2197C72.7045 99.4171 74.66 101.285 76.9475 102.666C79.2349 104.047 81.7983 104.908 84.4558 105.188V118.119C85.663 118.059 86.8775 118.124 88.0921 118.146V105.164C89.1177 105.074 90.1335 104.895 91.1284 104.63C91.7434 106.861 92.9816 108.871 94.6979 110.424C96.4142 111.976 98.5375 113.008 100.819 113.397V127.673H104.139C104.248 127.675 104.355 127.697 104.455 127.738V113.411C107.42 112.959 110.11 111.42 112.002 109.093C113.586 110.097 115.342 110.797 117.182 111.157V118.389H120.819V111.45C123.079 111.356 125.288 110.751 127.281 109.681C129.274 108.612 131 107.105 132.327 105.273C133.242 106.141 134.262 106.89 135.364 107.502V140.831ZM155.22 89.0047C152.7 89.6083 154.389 92.4828 154.201 94.1555C154.214 97.2226 153.009 100.169 150.851 102.349C148.694 104.529 145.76 105.765 142.693 105.784C140.905 105.786 139.142 105.366 137.547 104.56C135.952 103.753 134.569 102.582 133.511 101.141C133.323 100.895 133.076 100.701 132.792 100.577C132.509 100.452 132.198 100.402 131.89 100.43C131.582 100.458 131.286 100.563 131.029 100.736C130.773 100.91 130.565 101.145 130.424 101.421C129.653 102.98 128.538 104.343 127.163 105.408C125.788 106.473 124.189 107.212 122.487 107.569C120.785 107.926 119.024 107.892 117.337 107.47C115.65 107.047 114.081 106.247 112.748 105.13C112.543 104.958 112.304 104.834 112.046 104.765C111.788 104.696 111.519 104.684 111.256 104.731C110.993 104.777 110.744 104.881 110.526 105.034C110.307 105.187 110.125 105.386 109.992 105.617C109.106 107.183 107.739 108.423 106.094 109.151C104.449 109.879 102.613 110.058 100.858 109.661C99.1033 109.263 97.5233 108.311 96.3523 106.945C95.1813 105.579 94.4818 103.872 94.3574 102.077C94.3188 101.622 94.1114 101.198 93.776 100.888C93.4405 100.578 93.0013 100.405 92.5447 100.403C76.4778 106.986 63.989 86.4502 77.3359 75.3196C78.2468 74.6287 77.9414 73.4069 77.8777 72.4324C77.8681 70.1839 78.7506 68.0235 80.3318 66.4249C81.913 64.8263 84.0637 63.9202 86.3121 63.9053C88.209 63.9142 90.045 64.5754 91.512 65.778C91.759 65.9715 92.0517 66.0983 92.3619 66.1462C92.6721 66.194 92.9893 66.1614 93.2833 66.0513C93.5772 65.9412 93.8378 65.7574 94.0403 65.5176C94.2427 65.2777 94.3801 64.9899 94.4392 64.6816C94.7351 63.049 95.5069 61.5402 96.6576 60.3448C97.8083 59.1495 99.2866 58.3208 100.907 57.963C102.527 57.6051 104.217 57.7341 105.764 58.3336C107.311 58.9331 108.646 59.9765 109.602 61.3326C109.812 61.6228 110.101 61.8454 110.436 61.9728C110.77 62.1002 111.134 62.1269 111.484 62.0495C111.833 61.9721 112.152 61.7941 112.401 61.5375C112.65 61.2808 112.819 60.9568 112.886 60.6054C113.254 58.5257 114.39 56.6603 116.069 55.3792C117.748 54.0982 119.848 53.4951 121.951 53.6896C124.054 53.8842 126.007 54.8621 127.422 56.4294C128.838 57.9967 129.613 60.0389 129.593 62.1508C129.6 62.5304 129.724 62.8984 129.95 63.2039C130.175 63.5094 130.49 63.7372 130.851 63.8556C131.211 63.9741 131.6 63.9775 131.963 63.8652C132.325 63.7529 132.644 63.5305 132.875 63.2289C133.775 62.0116 134.989 61.0609 136.387 60.4777C137.784 59.8944 139.313 59.7005 140.812 59.9164C142.311 60.1322 143.724 60.7499 144.9 61.7038C146.076 62.6577 146.972 63.9123 147.493 65.3343C147.653 65.7665 147.971 66.1218 148.383 66.3286C148.795 66.5354 149.27 66.5784 149.712 66.4489C165.143 62.5635 170.612 85.2175 155.22 89.0047Z"
				fill="#C7C7C7"
			/>
			<path
				d="M93.4646 120.655C93.2228 130.201 79.2322 130.199 78.9922 120.655C79.234 111.11 93.2246 111.112 93.4646 120.655ZM109.828 129.746C109.586 139.291 95.5954 139.289 95.3554 129.746C95.5973 120.201 109.588 120.203 109.828 129.746ZM126.191 120.772C125.949 130.317 111.959 130.315 111.719 120.772C111.961 111.226 125.951 111.228 126.191 120.772Z"
				fill="white"
			/>
			<path
				d="M117 93C122.523 93 127 88.5228 127 83C127 77.4772 122.523 73 117 73C111.477 73 107 77.4772 107 83C107 88.5228 111.477 93 117 93Z"
				fill="#C7C7C7"
			/>
			<path
				d="M118.059 83.0004L120.359 80.7004C120.649 80.4104 120.649 79.9304 120.359 79.6404C120.069 79.3504 119.589 79.3504 119.299 79.6404L116.999 81.9404L114.699 79.6404C114.409 79.3504 113.929 79.3504 113.639 79.6404C113.349 79.9304 113.349 80.4104 113.639 80.7004L115.939 83.0004L113.639 85.3004C113.349 85.5904 113.349 86.0704 113.639 86.3604C113.789 86.5104 113.979 86.5804 114.169 86.5804C114.359 86.5804 114.549 86.5104 114.699 86.3604L116.999 84.0604L119.299 86.3604C119.449 86.5104 119.639 86.5804 119.829 86.5804C120.019 86.5804 120.209 86.5104 120.359 86.3604C120.649 86.0704 120.649 85.5904 120.359 85.3004L118.059 83.0004Z"
				fill="white"
			/>
		</svg>
	);
};

export function AiInsightsIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M2.91621 17.0833C3.60788 17.775 4.72454 17.775 5.41621 17.0833L16.2495 6.24995C16.9412 5.55828 16.9412 4.44162 16.2495 3.74995C15.5579 3.05828 14.4412 3.05828 13.7495 3.74995L2.91621 14.5833C2.22454 15.275 2.22454 16.3916 2.91621 17.0833Z"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M15.0088 7.4917L12.5088 4.9917"
				stroke="#7D7D7D"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M7.08301 2.03341L8.33301 1.66675L7.96634 2.91675L8.33301 4.16675L7.08301 3.80008L5.83301 4.16675L6.19967 2.91675L5.83301 1.66675L7.08301 2.03341Z"
				stroke="#7D7D7D"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M3.75 7.03341L5 6.66675L4.63333 7.91675L5 9.16675L3.75 8.80008L2.5 9.16675L2.86667 7.91675L2.5 6.66675L3.75 7.03341Z"
				stroke="#7D7D7D"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M16.25 11.1999L17.5 10.8333L17.1333 12.0833L17.5 13.3333L16.25 12.9666L15 13.3333L15.3667 12.0833L15 10.8333L16.25 11.1999Z"
				stroke="#7D7D7D"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function AcceptIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M4 10L7.99529 14L16 6"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function RejectIcon(props: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path
				d="M6 14L14 6"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M14 14L6 6"
				stroke="#5C5C5C"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function GalleryIcon(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M2.1487 15.8414L2.13203 15.8581C1.90703 15.3664 1.76536 14.8081 1.70703 14.1914C1.76536 14.7997 1.9237 15.3497 2.1487 15.8414Z"
				fill="#5C5C5C"
			/>
			<path
				d="M7.49896 8.65026C8.59432 8.65026 9.48229 7.76229 9.48229 6.66693C9.48229 5.57156 8.59432 4.68359 7.49896 4.68359C6.40359 4.68359 5.51562 5.57156 5.51562 6.66693C5.51562 7.76229 6.40359 8.65026 7.49896 8.65026Z"
				fill="#5C5C5C"
			/>
			<path
				d="M13.1179 2H6.55213C3.70019 2 2 3.70019 2 6.55213V13.1179C2 13.9719 2.14886 14.7162 2.43876 15.343C3.11257 16.8317 4.55421 17.67 6.55213 17.67H13.1179C15.9698 17.67 17.67 15.9698 17.67 13.1179V11.3237V6.55213C17.67 3.70019 15.9698 2 13.1179 2ZM16.3929 10.2268C15.7818 9.70181 14.7946 9.70181 14.1834 10.2268L10.9241 13.0238C10.3129 13.5488 9.32573 13.5488 8.71459 13.0238L8.4482 12.8045C7.89192 12.3187 7.00657 12.2717 6.37977 12.6948L3.44947 14.6614C3.2771 14.2226 3.17525 13.7133 3.17525 13.1179V6.55213C3.17525 4.34266 4.34266 3.17525 6.55213 3.17525H13.1179C15.3273 3.17525 16.4948 4.34266 16.4948 6.55213V10.3129L16.3929 10.2268Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
}

export function CommentIconBlack(props: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M10.993 5H5.65964C5.44297 5 5.23464 5.00833 5.03464 5.03333C2.79297 5.225 1.66797 6.55 1.66797 8.99167V12.325C1.66797 15.6583 3.0013 16.3167 5.65964 16.3167H5.99297C6.1763 16.3167 6.41797 16.4417 6.5263 16.5833L7.5263 17.9167C7.96797 18.5083 8.68464 18.5083 9.1263 17.9167L10.1263 16.5833C10.2513 16.4167 10.4513 16.3167 10.6596 16.3167H10.993C13.4346 16.3167 14.7596 15.2 14.9513 12.95C14.9763 12.75 14.9846 12.5417 14.9846 12.325V8.99167C14.9846 6.33333 13.6513 5 10.993 5ZM5.41797 11.6667C4.9513 11.6667 4.58464 11.2917 4.58464 10.8333C4.58464 10.375 4.95964 10 5.41797 10C5.8763 10 6.2513 10.375 6.2513 10.8333C6.2513 11.2917 5.8763 11.6667 5.41797 11.6667ZM8.3263 11.6667C7.85964 11.6667 7.49297 11.2917 7.49297 10.8333C7.49297 10.375 7.86797 10 8.3263 10C8.78464 10 9.15964 10.375 9.15964 10.8333C9.15964 11.2917 8.79297 11.6667 8.3263 11.6667ZM11.243 11.6667C10.7763 11.6667 10.4096 11.2917 10.4096 10.8333C10.4096 10.375 10.7846 10 11.243 10C11.7013 10 12.0763 10.375 12.0763 10.8333C12.0763 11.2917 11.7013 11.6667 11.243 11.6667Z"
				fill="#5C5C5C"
			/>
			<path
				d="M18.3162 5.65866V8.99199C18.3162 10.6587 17.7996 11.792 16.7662 12.417C16.5162 12.567 16.2246 12.367 16.2246 12.0753L16.2329 8.99199C16.2329 5.65866 14.3246 3.75033 10.9912 3.75033L5.91622 3.75866C5.62455 3.75866 5.42455 3.46699 5.57455 3.21699C6.19955 2.18366 7.33289 1.66699 8.99122 1.66699H14.3246C16.9829 1.66699 18.3162 3.00033 18.3162 5.65866Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
}

export function TickGreen(props: Props) {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="18" cy="18" r="18" fill="#00C853" />
			<path
				d="M10.7852 18.0061L15.5795 22.8061L25.1852 13.2061"
				stroke="white"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function CrossRed(props: Props) {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="18" cy="18" r="18" fill="#F26184" />
			<path
				d="M13.1836 22.8061L22.7836 13.2061"
				stroke="white"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M22.7836 22.8061L13.1836 13.2061"
				stroke="white"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function PartialAcceptedIcon(props: Props) {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M31.5546 6.35412L6.35412 31.5546C6.31812 31.5906 6.30012 31.6086 6.26412 31.6266C5.58011 31.0506 4.95009 30.4206 4.37408 29.7366C1.63803 26.5865 0 22.4824 0 18.0003C0 8.06415 8.06415 0 18.0003 0C22.4824 0 26.5865 1.63803 29.7366 4.37408C30.4206 4.95009 31.0506 5.58011 31.6266 6.26412C31.6086 6.30012 31.5906 6.31812 31.5546 6.35412Z"
				fill="#00C853"
			/>
			<path
				d="M36.0005 18.0001C36.0005 27.8823 27.8823 36.0005 18.0001 36.0005C15.3001 36.0005 12.744 35.4064 10.44 34.3264C9.32394 33.8044 9.10794 32.3104 9.97195 31.4284L31.4284 9.97195C32.2924 9.10794 33.8044 9.32394 34.3264 10.44C35.4064 12.726 36.0005 15.3001 36.0005 18.0001Z"
				fill="#00C853"
			/>
			<path
				d="M35.5816 0.41282C35.0416 -0.12719 34.1596 -0.12719 33.6196 0.41282L0.408914 33.6415C-0.131096 34.1815 -0.131096 35.0635 0.408914 35.6035C0.678919 35.8555 1.02093 35.9995 1.38093 35.9995C1.74094 35.9995 2.08295 35.8555 2.35295 35.5855L35.5816 2.35686C36.1396 1.81685 36.1396 0.952831 35.5816 0.41282Z"
				fill="#00C853"
			/>
		</svg>
	);
}

export function SaveForReviewIcon(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.0156 1.66699H5.98229C4.20729 1.66699 2.76562 3.11699 2.76562 4.88366V16.6253C2.76562 18.1253 3.84063 18.7587 5.15729 18.0337L9.22396 15.7753C9.65729 15.5337 10.3573 15.5337 10.7823 15.7753L14.849 18.0337C16.1656 18.767 17.2406 18.1337 17.2406 16.6253V4.88366C17.2323 3.11699 15.7906 1.66699 14.0156 1.66699Z"
				fill="#FFBE00"
				stroke="#FFBE00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M7.99219 9.16634L9.24219 10.4163L12.5755 7.08301"
				stroke="white"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function ComingSoonImage(props: Props) {
	return (
		<svg
			width="129"
			height="134"
			viewBox="0 0 129 134"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_28_984)">
				<path
					d="M100.762 120.433C101.11 120.208 101.209 119.743 100.983 119.396C100.757 119.048 100.293 118.95 99.9454 119.175L100.762 120.433ZM118.397 34.8892L117.475 26.2782L110.479 31.3823L118.397 34.8892ZM99.9454 119.175C71.8617 137.416 34.3084 129.436 16.0679 101.353L14.8099 102.17C33.5017 130.948 71.984 139.125 100.762 120.433L99.9454 119.175ZM16.0679 101.353C-2.17274 73.269 5.8067 35.7158 33.8904 17.4752L33.0734 16.2172C4.2949 34.9091 -3.88193 73.3913 14.8099 102.17L16.0679 101.353ZM33.8904 17.4752C60.0855 0.461277 94.5203 6.25939 113.835 29.9068L114.997 28.9579C95.2032 4.72426 59.9173 -1.21812 33.0734 16.2172L33.8904 17.4752Z"
					fill="#ACACAC"
				/>
				<circle cx="68.0043" cy="68.9145" r="55.1684" fill="#FFFDF5" />
				<circle cx="67.7479" cy="69.1698" r="48.6932" fill="#FFF9E6" />
				<circle
					cx="68.0095"
					cy="68.9118"
					r="42.7361"
					fill="url(#paint0_linear_28_984)"
					fill-opacity="0.8"
				/>
				<circle cx="68.006" cy="31.0997" r="1.29503" fill="#1A1D1F" />
				<circle cx="94.42" cy="40.9396" r="1.29503" fill="#1A1D1F" />
				<circle cx="105.818" cy="67.3614" r="1.29503" fill="#1A1D1F" />
				<circle cx="94.42" cy="94.295" r="1.29503" fill="#1A1D1F" />
				<circle cx="68.5216" cy="106.729" r="1.29503" fill="#1A1D1F" />
				<circle cx="41.5841" cy="94.295" r="1.29503" fill="#1A1D1F" />
				<circle cx="30.1935" cy="67.3614" r="1.29503" fill="#1A1D1F" />
				<circle cx="41.5841" cy="40.9396" r="1.29503" fill="#1A1D1F" />
				<rect
					x="67.7422"
					y="50.5234"
					width="1.03603"
					height="17.0944"
					rx="0.518013"
					fill="#1A1D1F"
				/>
				<path
					d="M68.0951 67.9692C67.8943 67.7671 67.8748 67.4473 68.0496 67.2223C68.2596 66.9519 68.6597 66.9281 68.9003 67.1718L89.3539 87.8925C89.5548 88.096 89.5531 88.4236 89.3503 88.6251C89.147 88.827 88.8186 88.8259 88.6166 88.6226L68.0951 67.9692Z"
					fill="#1A1D1F"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_28_984"
					x1="25.2734"
					y1="15.0961"
					x2="102.93"
					y2="132.192"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#FFE599" />
					<stop offset="1" stop-color="#FFBE00" />
				</linearGradient>
				<clipPath id="clip0_28_984">
					<rect width="129" height="134" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function TickCircle(props: Props) {
	return (
		<svg
			width="92"
			height="102"
			viewBox="0 0 92 102"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_28_974)">
				<path
					d="M46.0029 82.4985C66.7136 82.4985 83.5029 65.7092 83.5029 44.9985C83.5029 24.2879 66.7136 7.49854 46.0029 7.49854C25.2923 7.49854 8.50293 24.2879 8.50293 44.9985C8.50293 65.7092 25.2923 82.4985 46.0029 82.4985Z"
					fill="#00D559"
				/>
			</g>
			<path
				d="M40.6715 58.4245C39.9215 58.4245 39.209 58.1245 38.684 57.5995L28.0715 46.987C26.984 45.8995 26.984 44.0995 28.0715 43.012C29.159 41.9245 30.959 41.9245 32.0465 43.012L40.6715 51.637L59.9465 32.362C61.034 31.2745 62.834 31.2745 63.9215 32.362C65.009 33.4495 65.009 35.2495 63.9215 36.337L42.659 57.5995C42.134 58.1245 41.4215 58.4245 40.6715 58.4245Z"
				fill="white"
			/>
			<defs>
				<filter
					id="filter0_d_28_974"
					x="0.50293"
					y="7.49854"
					width="91"
					height="94"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="11" />
					<feGaussianBlur stdDeviation="4" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0.784314 0 0 0 0 0.32549 0 0 0 0.16 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28_974" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_28_974"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
}

export function FinanceIcon(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.6665 7.08334H10.8332"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M5 13.75H6.66667"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M8.75 13.75H12.0833"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M18.3332 9.44167V13.425C18.3332 16.35 17.5915 17.0833 14.6332 17.0833H5.3665C2.40817 17.0833 1.6665 16.35 1.6665 13.425V6.575C1.6665 3.65 2.40817 2.91666 5.3665 2.91666H11.0665"
				stroke="#1A1D1F"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M14.1665 6.0065C14.1665 6.68011 14.6873 7.22178 15.3262 7.22178H16.6318C17.1873 7.22178 17.6387 6.74956 17.6387 6.15928C17.6387 5.52734 17.361 5.29817 16.9512 5.15234L14.8609 4.42317C14.4512 4.27734 14.1735 4.05512 14.1735 3.41623C14.1735 2.8329 14.6248 2.35373 15.1804 2.35373H16.4859C17.1248 2.35373 17.6457 2.8954 17.6457 3.56901"
				stroke="#1A1D1F"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
			<path
				d="M15.8965 1.66666V7.91666"
				stroke="#1A1D1F"
				stroke-linecap="round"
				stroke-linejoin="round"
				{...props}
			/>
		</svg>
	);
}

export function ArrowRightOrange(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.125 10H16.875"
				stroke="#FF6120"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11.25 4.375L16.875 10L11.25 15.625"
				stroke="#FF6120"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function CommentIconTextField(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.3913 14.0248L15.7163 16.6582C15.7997 17.3498 15.058 17.8332 14.4663 17.4748L11.583 15.7582C11.383 15.6415 11.333 15.3915 11.4413 15.1915C11.858 14.4248 12.083 13.5582 12.083 12.6915C12.083 9.6415 9.46633 7.15817 6.24967 7.15817C5.59133 7.15817 4.94967 7.25817 4.34967 7.45817C4.04133 7.55817 3.74133 7.27484 3.81633 6.95817C4.57467 3.92484 7.49133 1.6665 10.9747 1.6665C15.0413 1.6665 18.333 4.7415 18.333 8.53317C18.333 10.7832 17.1747 12.7748 15.3913 14.0248Z"
				fill="#5C5C5C"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.8513 15.3249C10.468 14.5999 10.8346 13.6832 10.8346 12.6915C10.8346 10.3249 8.78464 8.4082 6.2513 8.4082C5.28464 8.4082 4.39297 8.6832 3.6513 9.16654C2.4513 9.9332 1.66797 11.2249 1.66797 12.6915C1.66797 14.0915 2.38464 15.3332 3.5013 16.1082L3.29297 17.7499C3.24297 18.1749 3.70964 18.4832 4.0763 18.2582L6.2513 16.9665C7.71797 16.9665 9.0263 16.3249 9.8513 15.3249ZM4.77734 11.4422C5.20962 11.0096 5.79295 10.8011 6.36065 10.8376C6.86064 10.8636 7.35022 11.0669 7.72521 11.4474C8.00125 11.7237 8.18875 12.0625 8.27208 12.4222C8.44395 13.105 8.26166 13.8608 7.72521 14.3977C7.34501 14.7782 6.86064 14.9763 6.36585 14.9971C6.15752 15.0075 5.94919 14.9919 5.75128 14.9398C5.39191 14.8512 5.05337 14.6687 4.77734 14.3925C3.96485 13.5741 3.96485 12.2554 4.77734 11.4422ZM7.30334 13.1832C7.37626 13.1102 7.41792 13.0164 7.41792 12.9069C7.41792 12.6932 7.24605 12.516 7.0273 12.516H6.64189V12.1459C6.64189 11.9322 6.46481 11.755 6.25127 11.755C6.03773 11.755 5.86065 11.9322 5.86065 12.1459V12.516H5.47003C5.2565 12.516 5.07941 12.6932 5.07941 12.9069C5.07941 13.1206 5.2565 13.2979 5.47003 13.2979H5.86065V13.7044C5.86065 13.9181 6.03773 14.0954 6.25127 14.0954C6.36065 14.0954 6.4544 14.0537 6.52731 13.9807C6.60023 13.9077 6.64189 13.8139 6.64189 13.7044V13.2979H7.0273C7.13668 13.2979 7.23043 13.2562 7.30334 13.1832Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
}

export function MarketplaceShopIcon(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.4">
				<path
					d="M2.50781 9.34985V13.0915C2.50781 16.8332 4.00781 18.3332 7.74948 18.3332H12.2411C15.9828 18.3332 17.4828 16.8332 17.4828 13.0915V9.34985"
					fill="white"
				/>
				<path
					d="M2.50781 9.34985V13.0915C2.50781 16.8332 4.00781 18.3332 7.74948 18.3332H12.2411C15.9828 18.3332 17.4828 16.8332 17.4828 13.0915V9.34985"
					stroke="#E6AE06"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.99935 14.1667C8.60768 14.1667 7.91602 14.8584 7.91602 16.2501V18.3334H12.0827V16.2501C12.0827 14.8584 11.391 14.1667 9.99935 14.1667Z"
					fill="#E6AE06"
				/>
			</g>
			<path
				d="M9.99975 10.0001C11.5247 10.0001 12.6497 8.75841 12.4997 7.23341L11.9497 1.66675H8.05808L7.49975 7.23341C7.34975 8.75841 8.47475 10.0001 9.99975 10.0001Z"
				fill="white"
				stroke="#5E94FF"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.2587 10.0001C16.942 10.0001 18.1753 8.63341 18.0087 6.95842L17.7753 4.66675C17.4753 2.50008 16.642 1.66675 14.4587 1.66675H11.917L12.5003 7.50841C12.642 8.88341 13.8837 10.0001 15.2587 10.0001Z"
				fill="white"
				stroke="#5E94FF"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M4.69966 10.0001C6.07466 10.0001 7.31632 8.88341 7.44966 7.50841L7.63299 5.66675L8.03299 1.66675H5.49133C3.30799 1.66675 2.47466 2.50008 2.17466 4.66675L1.94966 6.95842C1.78299 8.63341 3.01632 10.0001 4.69966 10.0001Z"
				fill="white"
				stroke="#5E94FF"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}

export function HamburgerCollapseIcon(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM4 18H8C8.55 18 9 17.55 9 17C9 16.45 8.55 16 8 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM14 13H4C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11H14C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13Z"
				fill="#5C5C5C"
			/>
			<mask
				id="mask0_438_1374"
				// style="mask-type:luminance"
				maskUnits="userSpaceOnUse"
				x="3"
				y="6"
				width="18"
				height="12"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM4 18H8C8.55 18 9 17.55 9 17C9 16.45 8.55 16 8 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM14 13H4C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11H14C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_438_1374)"></g>
		</svg>
	);
}

export function HamburgerIcon(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
				fill="#5C5C5C"
			/>
			<mask
				id="mask0_438_1591"
				// style="mask-type:luminance"
				maskUnits="userSpaceOnUse"
				x="3"
				y="6"
				width="18"
				height="12"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_438_1591)"></g>
		</svg>
	);
}

export function BulletIcon(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.99935 1.66663C5.39935 1.66663 1.66602 5.39996 1.66602 9.99996C1.66602 14.6 5.39935 18.3333 9.99935 18.3333C14.5993 18.3333 18.3327 14.6 18.3327 9.99996C18.3327 5.39996 14.5993 1.66663 9.99935 1.66663ZM9.99935 12.0833C8.84935 12.0833 7.91602 11.15 7.91602 9.99996C7.91602 8.84996 8.84935 7.91663 9.99935 7.91663C11.1493 7.91663 12.0827 8.84996 12.0827 9.99996C12.0827 11.15 11.1493 12.0833 9.99935 12.0833Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function QuestionMarkIcon(props: Props) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.99922 0.43103C6.5307 0.43103 5.09515 0.866499 3.87411 1.68237C2.65308 2.49824 1.7014 3.65787 1.13942 5.01461C0.577436 6.37135 0.430396 7.86427 0.716891 9.30458C1.00339 10.7449 1.71055 12.0679 2.74895 13.1063C3.78736 14.1447 5.11037 14.8519 6.55068 15.1384C7.99099 15.4249 9.48391 15.2778 10.8406 14.7158C12.1974 14.1539 13.357 13.2022 14.1729 11.9811C14.9888 10.7601 15.4242 9.32456 15.4242 7.85603C15.4242 5.8868 14.6419 3.99822 13.2495 2.60576C11.857 1.21331 9.96846 0.43103 7.99922 0.43103ZM8.46722 11.501C8.31887 11.641 8.12221 11.7184 7.91822 11.717C7.8162 11.719 7.71485 11.7001 7.62043 11.6614C7.526 11.6227 7.44051 11.565 7.36922 11.492C7.29689 11.4221 7.23962 11.3381 7.20093 11.2453C7.16224 11.1524 7.14294 11.0526 7.14422 10.952C7.14009 10.8511 7.15808 10.7504 7.19695 10.6571C7.23582 10.5638 7.29461 10.4802 7.36922 10.412C7.44127 10.3406 7.52711 10.2847 7.6215 10.2475C7.71588 10.2104 7.81684 10.1929 7.91822 10.196C8.02104 10.1922 8.12355 10.2093 8.2195 10.2465C8.31545 10.2836 8.40281 10.34 8.47622 10.412C8.55083 10.4802 8.60963 10.5638 8.6485 10.6571C8.68736 10.7504 8.70536 10.8511 8.70122 10.952C8.70275 11.0561 8.68275 11.1594 8.64248 11.2555C8.60222 11.3515 8.54255 11.4382 8.46722 11.51V11.501ZM9.99722 7.36103C9.71302 7.65373 9.41255 7.93017 9.09722 8.18903C8.91216 8.3379 8.76168 8.52522 8.65622 8.73803C8.53973 8.95341 8.48083 9.19521 8.48522 9.44003V9.62003H7.36022V9.44003C7.34761 9.09133 7.42183 8.74495 7.57622 8.43203C7.89666 7.92601 8.29799 7.47602 8.76422 7.10003L8.94422 6.90203C9.12832 6.68529 9.23307 6.41229 9.24122 6.12803C9.23595 5.81873 9.11376 5.5229 8.89922 5.30003C8.77792 5.18998 8.63575 5.1054 8.48116 5.05129C8.32656 4.99718 8.16268 4.97465 7.99922 4.98503C7.80205 4.96855 7.60389 5.00195 7.42302 5.08216C7.24215 5.16238 7.08437 5.28682 6.96422 5.44403C6.75605 5.76435 6.65518 6.14259 6.67622 6.52403H5.59622C5.58129 6.19472 5.63253 5.86575 5.74692 5.55658C5.86132 5.24741 6.03653 4.96432 6.26222 4.72403C6.50739 4.49154 6.79757 4.31171 7.11488 4.19563C7.43219 4.07954 7.7699 4.02965 8.10722 4.04903C8.71612 3.99694 9.32178 4.18057 9.79922 4.56203C10.0133 4.75118 10.1819 4.98617 10.2925 5.24952C10.4032 5.51286 10.453 5.79777 10.4382 6.08303C10.4418 6.5497 10.2863 7.00366 9.99722 7.37003V7.36103Z"
				fill="#979797"
			/>
		</svg>
	);
}

export function EyeIcon(props: Props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.7077 7.62506C15.7827 4.60006 12.966 2.8584 9.99935 2.8584C8.51602 2.8584 7.07435 3.29173 5.75768 4.10007C4.44102 4.91673 3.25768 6.1084 2.29102 7.62506C1.45768 8.9334 1.45768 11.0584 2.29102 12.3667C4.21602 15.4001 7.03268 17.1334 9.99935 17.1334C11.4827 17.1334 12.9243 16.7001 14.241 15.8917C15.5577 15.0751 16.741 13.8834 17.7077 12.3667C18.541 11.0667 18.541 8.9334 17.7077 7.62506ZM9.99935 13.3667C8.13268 13.3667 6.63268 11.8584 6.63268 10.0001C6.63268 8.14173 8.13268 6.6334 9.99935 6.6334C11.866 6.6334 13.366 8.14173 13.366 10.0001C13.366 11.8584 11.866 13.3667 9.99935 13.3667Z"
				fill="#FFBE00"
			/>
			<path
				d="M10 7.6167C8.69167 7.6167 7.625 8.68337 7.625 10C7.625 11.3084 8.69167 12.375 10 12.375C11.3083 12.375 12.3833 11.3084 12.3833 10C12.3833 8.6917 11.3083 7.6167 10 7.6167Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function NotificationIcon(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z"
				fill="#5C5C5C"
			/>
			<path
				d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
}

export function AlertCircleIcon(props: Props) {
	return (
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="24" fill="#FCDFE6" />
			<path
				d="M31.5099 17.85L25.5699 14.42C24.5999 13.86 23.3999 13.86 22.4199 14.42L16.4899 17.85C15.5199 18.41 14.9199 19.45 14.9199 20.58V27.42C14.9199 28.54 15.5199 29.58 16.4899 30.15L22.4299 33.58C23.3999 34.14 24.5999 34.14 25.5799 33.58L31.5199 30.15C32.4899 29.59 33.0899 28.55 33.0899 27.42V20.58C33.0799 19.45 32.4799 18.42 31.5099 17.85ZM23.2499 19.75C23.2499 19.34 23.5899 19 23.9999 19C24.4099 19 24.7499 19.34 24.7499 19.75V25C24.7499 25.41 24.4099 25.75 23.9999 25.75C23.5899 25.75 23.2499 25.41 23.2499 25V19.75ZM24.9199 28.63C24.8699 28.75 24.7999 28.86 24.7099 28.96C24.5199 29.15 24.2699 29.25 23.9999 29.25C23.8699 29.25 23.7399 29.22 23.6199 29.17C23.4899 29.12 23.3899 29.05 23.2899 28.96C23.1999 28.86 23.1299 28.75 23.0699 28.63C23.0199 28.51 22.9999 28.38 22.9999 28.25C22.9999 27.99 23.0999 27.73 23.2899 27.54C23.3899 27.45 23.4899 27.38 23.6199 27.33C23.9899 27.17 24.4299 27.26 24.7099 27.54C24.7999 27.64 24.8699 27.74 24.9199 27.87C24.9699 27.99 24.9999 28.12 24.9999 28.25C24.9999 28.38 24.9699 28.51 24.9199 28.63Z"
				fill="#F26184"
			/>
		</svg>
	);
}

export function SendIcon(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.07 8.50989L9.51002 4.22989C3.76002 1.34989 1.40002 3.70989 4.28002 9.45989L5.15002 11.1999C5.40002 11.7099 5.40002 12.2999 5.15002 12.8099L4.28002 14.5399C1.40002 20.2899 3.75002 22.6499 9.51002 19.7699L18.07 15.4899C21.91 13.5699 21.91 10.4299 18.07 8.50989ZM14.84 12.7499H9.44002C9.03002 12.7499 8.69002 12.4099 8.69002 11.9999C8.69002 11.5899 9.03002 11.2499 9.44002 11.2499H14.84C15.25 11.2499 15.59 11.5899 15.59 11.9999C15.59 12.4099 15.25 12.7499 14.84 12.7499Z"
				fill="#5C5C5C"
			/>
		</svg>
	);
}

export function OrderCartIcon2(props: Props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.5416 18.7499C14.3471 18.7499 15 18.097 15 17.2916C15 16.4862 14.3471 15.8333 13.5416 15.8333C12.7362 15.8333 12.0833 16.4862 12.0833 17.2916C12.0833 18.097 12.7362 18.7499 13.5416 18.7499Z"
				fill="black"
				{...props}
			/>
			<path
				d="M6.87502 18.7499C7.68044 18.7499 8.33335 18.097 8.33335 17.2916C8.33335 16.4862 7.68044 15.8333 6.87502 15.8333C6.06961 15.8333 5.41669 16.4862 5.41669 17.2916C5.41669 18.097 6.06961 18.7499 6.87502 18.7499Z"
				fill="black"
				{...props}
			/>
			<path
				d="M4.03335 3.28341L3.86669 5.32508C3.83335 5.71675 4.14169 6.04175 4.53335 6.04175H17.2917C17.6417 6.04175 17.9334 5.77508 17.9584 5.42508C18.0667 3.95008 16.9417 2.75008 15.4667 2.75008H5.22502C5.14169 2.38341 4.97502 2.03341 4.71669 1.74175C4.30002 1.30008 3.71669 1.04175 3.11669 1.04175H1.66669C1.32502 1.04175 1.04169 1.32508 1.04169 1.66675C1.04169 2.00841 1.32502 2.29175 1.66669 2.29175H3.11669C3.37502 2.29175 3.61669 2.40008 3.79169 2.58341C3.96669 2.77508 4.05002 3.02508 4.03335 3.28341Z"
				fill="black"
				{...props}
			/>
			<path
				d="M17.0917 7.29175H4.30836C3.95836 7.29175 3.67502 7.55841 3.64169 7.90008L3.34169 11.5251C3.22502 12.9501 4.34169 14.1667 5.76669 14.1667H15.0334C16.2834 14.1667 17.3834 13.1417 17.475 11.8917L17.75 8.00008C17.7834 7.61675 17.4834 7.29175 17.0917 7.29175Z"
				fill="black"
				{...props}
			/>
		</svg>
	);
}

export function OrderBookIcon(props: Props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.07 6.25 8.66 5.84C8.25 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z"
				fill="#7D7D7D"
				{...props}
			/>
			<path
				d="M18.83 5.02996C18.6 4.83996 18.34 4.68996 18.06 4.57996C17.77 4.46996 17.48 4.69996 17.42 4.99996C17.08 6.70996 15.57 7.99996 13.75 7.99996H10.25C9.25 7.99996 8.31 7.60996 7.6 6.89996C7.08 6.37996 6.72 5.71996 6.58 5.00996C6.52 4.70996 6.22 4.46996 5.93 4.58996C4.77 5.05996 4 6.11996 4 8.24996V18C4 21 5.79 22 8 22H16C18.21 22 20 21 20 18V8.24996C20 6.61996 19.55 5.61996 18.83 5.02996ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
				fill="#7D7D7D"
				{...props}
			/>
		</svg>
	);
}

export function CartRemoveIcon(props: Props) {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21.05 28.5C22.0165 28.5 22.8 27.7165 22.8 26.75C22.8 25.7835 22.0165 25 21.05 25C20.0835 25 19.3 25.7835 19.3 26.75C19.3 27.7165 20.0835 28.5 21.05 28.5Z"
				fill="#7D7D7D"
			/>
			<path
				d="M13.05 28.5C14.0165 28.5 14.8 27.7165 14.8 26.75C14.8 25.7835 14.0165 25 13.05 25C12.0835 25 11.3 25.7835 11.3 26.75C11.3 27.7165 12.0835 28.5 13.05 28.5Z"
				fill="#7D7D7D"
			/>
			<path
				d="M9.63999 9.94L9.43999 12.39C9.39999 12.86 9.76999 13.25 10.24 13.25H25.55C25.97 13.25 26.32 12.93 26.35 12.51C26.48 10.74 25.13 9.3 23.36 9.3H11.07C10.97 8.86 10.77 8.44 10.46 8.09C9.95999 7.56 9.25999 7.25 8.53999 7.25H6.79999C6.38999 7.25 6.04999 7.59 6.04999 8C6.04999 8.41 6.38999 8.75 6.79999 8.75H8.53999C8.84999 8.75 9.13999 8.88 9.34999 9.1C9.55999 9.33 9.65999 9.63 9.63999 9.94Z"
				fill="#7D7D7D"
			/>
			<path
				d="M25.31 14.75H9.96998C9.54998 14.75 9.20998 15.07 9.16998 15.48L8.80998 19.83C8.66998 21.54 10.01 23 11.72 23H22.84C24.34 23 25.66 21.77 25.77 20.27L26.1 15.6C26.14 15.14 25.78 14.75 25.31 14.75Z"
				fill="#7D7D7D"
			/>
			<circle cx="24.5002" cy="10.5" r="3.5" fill="white" />
			<path
				d="M25.0002 5.16675C21.786 5.16675 19.1668 7.78591 19.1668 11.0001C19.1668 14.2142 21.786 16.8334 25.0002 16.8334C28.2143 16.8334 30.8335 14.2142 30.8335 11.0001C30.8335 7.78591 28.2143 5.16675 25.0002 5.16675ZM26.9602 12.3417C27.1293 12.5109 27.1293 12.7909 26.9602 12.9601C26.8727 13.0476 26.7618 13.0884 26.651 13.0884C26.5402 13.0884 26.4293 13.0476 26.3418 12.9601L25.0002 11.6184L23.6585 12.9601C23.571 13.0476 23.4602 13.0884 23.3493 13.0884C23.2385 13.0884 23.1277 13.0476 23.0402 12.9601C22.871 12.7909 22.871 12.5109 23.0402 12.3417L24.3818 11.0001L23.0402 9.65841C22.871 9.48925 22.871 9.20925 23.0402 9.04008C23.2093 8.87091 23.4893 8.87091 23.6585 9.04008L25.0002 10.3817L26.3418 9.04008C26.511 8.87091 26.791 8.87091 26.9602 9.04008C27.1293 9.20925 27.1293 9.48925 26.9602 9.65841L25.6185 11.0001L26.9602 12.3417Z"
				fill="#F26184"
			/>
		</svg>
	);
}

export function SaveForReviewIcon2(props: Props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M16.82 1.90991H7.18001C5.06001 1.90991 3.32001 3.64991 3.32001 5.76991V19.8599C3.32001 21.6599 4.61001 22.4199 6.19001 21.5499L11.07 18.8399C11.59 18.5499 12.43 18.5499 12.94 18.8399L17.82 21.5499C19.4 22.4299 20.69 21.6699 20.69 19.8599V5.76991C20.68 3.64991 18.95 1.90991 16.82 1.90991ZM15.62 9.02991L11.62 13.0299C11.47 13.1799 11.28 13.2499 11.09 13.2499C10.9 13.2499 10.71 13.1799 10.56 13.0299L9.06001 11.5299C8.77001 11.2399 8.77001 10.7599 9.06001 10.4699C9.35001 10.1799 9.83001 10.1799 10.12 10.4699L11.09 11.4399L14.56 7.96991C14.85 7.67991 15.33 7.67991 15.62 7.96991C15.91 8.25991 15.91 8.73991 15.62 9.02991Z"
				fill="#7D7D7D"
				{...props}
			/>
		</svg>
	);
}

export function SettingsIcon3(props: Props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20.1 9.22006C18.29 9.22006 17.55 7.94006 18.45 6.37006C18.97 5.46006 18.66 4.30006 17.75 3.78006L16.02 2.79006C15.23 2.32006 14.21 2.60006 13.74 3.39006L13.63 3.58006C12.73 5.15006 11.25 5.15006 10.34 3.58006L10.23 3.39006C9.78 2.60006 8.76 2.32006 7.97 2.79006L6.24 3.78006C5.33 4.30006 5.02 5.47006 5.54 6.38006C6.45 7.94006 5.71 9.22006 3.9 9.22006C2.86 9.22006 2 10.0701 2 11.1201V12.8801C2 13.9201 2.85 14.7801 3.9 14.7801C5.71 14.7801 6.45 16.0601 5.54 17.6301C5.02 18.5401 5.33 19.7001 6.24 20.2201L7.97 21.2101C8.76 21.6801 9.78 21.4001 10.25 20.6101L10.36 20.4201C11.26 18.8501 12.74 18.8501 13.65 20.4201L13.76 20.6101C14.23 21.4001 15.25 21.6801 16.04 21.2101L17.77 20.2201C18.68 19.7001 18.99 18.5301 18.47 17.6301C17.56 16.0601 18.3 14.7801 20.11 14.7801C21.15 14.7801 22.01 13.9301 22.01 12.8801V11.1201C22 10.0801 21.15 9.22006 20.1 9.22006ZM12 15.2501C10.21 15.2501 8.75 13.7901 8.75 12.0001C8.75 10.2101 10.21 8.75006 12 8.75006C13.79 8.75006 15.25 10.2101 15.25 12.0001C15.25 13.7901 13.79 15.2501 12 15.2501Z"
				fill="#FFBE00"
			/>
		</svg>
	);
}

export function CommentIcon2(props: Props) {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_854_7173)">
				<path
					d="M21.4699 19.83L21.8599 22.99C21.9599 23.82 21.0699 24.4 20.3599 23.97L16.8999 21.91C16.6599 21.77 16.5999 21.47 16.7299 21.23C17.2299 20.31 17.4999 19.27 17.4999 18.23C17.4999 14.57 14.3599 11.59 10.4999 11.59C9.70989 11.59 8.93989 11.71 8.21989 11.95C7.84989 12.07 7.48989 11.73 7.57989 11.35C8.48989 7.71 11.9899 5 16.1699 5C21.0499 5 24.9999 8.69 24.9999 13.24C24.9999 15.94 23.6099 18.33 21.4699 19.83Z"
					fill="#7D7D7D"
				/>
				<path
					d="M16.0015 18.2298C16.0015 19.4198 15.5615 20.5198 14.8215 21.3898C13.8315 22.5898 12.2615 23.3598 10.5015 23.3598L7.89146 24.9098C7.45146 25.1798 6.89146 24.8098 6.95146 24.2998L7.20146 22.3298C5.86146 21.3998 5.00146 19.9098 5.00146 18.2298C5.00146 16.4698 5.94146 14.9198 7.38146 13.9998C8.27146 13.4198 9.34146 13.0898 10.5015 13.0898C13.5415 13.0898 16.0015 15.3898 16.0015 18.2298Z"
					fill="#7D7D7D"
				/>
				<circle cx="22.5" cy="7.5" r="3.25" fill="#FFBE00" stroke="#F7F5F4" stroke-width="0.5" />
			</g>
			<defs>
				<clipPath id="clip0_854_7173">
					<rect width="30" height="30" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function EditIcon2(props: Props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.75 19.5H5.25C4.9425 19.5 4.6875 19.245 4.6875 18.9375C4.6875 18.63 4.9425 18.375 5.25 18.375H18.75C19.0575 18.375 19.3125 18.63 19.3125 18.9375C19.3125 19.245 19.0575 19.5 18.75 19.5Z"
				fill="#292D32"
				{...props}
			/>
			<path
				d="M17.2649 5.61024C15.8099 4.15524 14.3849 4.11774 12.8924 5.61024L11.9849 6.51774C11.9099 6.59274 11.8799 6.71274 11.9099 6.81774C12.4799 8.80524 14.0699 10.3952 16.0574 10.9652C16.0874 10.9727 16.1174 10.9802 16.1474 10.9802C16.2299 10.9802 16.3049 10.9502 16.3649 10.8902L17.2649 9.98274C18.0074 9.24774 18.3674 8.53524 18.3674 7.81524C18.3749 7.07274 18.0149 6.35274 17.2649 5.61024Z"
				fill="#292D32"
				{...props}
			/>
			<path
				d="M14.7075 11.6476C14.49 11.5426 14.28 11.4376 14.0775 11.3176C13.9125 11.2201 13.755 11.1151 13.5975 11.0026C13.47 10.9201 13.32 10.8001 13.1775 10.6801C13.1625 10.6726 13.11 10.6276 13.05 10.5676C12.8025 10.3576 12.525 10.0876 12.2775 9.7876C12.255 9.7726 12.2175 9.7201 12.165 9.6526C12.09 9.5626 11.9625 9.4126 11.85 9.2401C11.76 9.1276 11.655 8.9626 11.5575 8.7976C11.4375 8.5951 11.3325 8.3926 11.2275 8.1826C11.0898 7.88759 10.7026 7.79996 10.4724 8.03015L6.25499 12.2476C6.1575 12.3451 6.06749 12.5326 6.04499 12.6601L5.63999 15.5326C5.56499 16.0426 5.7075 16.5226 6.0225 16.8451C6.2925 17.1076 6.66749 17.2501 7.07249 17.2501C7.16249 17.2501 7.25249 17.2426 7.34249 17.2276L10.2225 16.8226C10.3575 16.8001 10.545 16.7101 10.635 16.6126L14.8594 12.3882C15.085 12.1626 15.0002 11.7744 14.7075 11.6476Z"
				fill="#292D32"
				{...props}
			/>
		</svg>
	);
}

export function PermissionIcon2(props: Props) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z"
				fill="#292D32"
				{...props}
			/>
			<path
				d="M12.81 10.6127C10.7175 9.21766 7.30497 9.21766 5.19747 10.6127C4.24497 11.2502 3.71997 12.1127 3.71997 13.0352C3.71997 13.9577 4.24497 14.8127 5.18997 15.4427C6.23997 16.1477 7.61997 16.5002 8.99997 16.5002C10.38 16.5002 11.76 16.1477 12.81 15.4427C13.755 14.8052 14.28 13.9502 14.28 13.0202C14.2725 12.0977 13.755 11.2427 12.81 10.6127Z"
				fill="#292D32"
				{...props}
			/>
			<circle cx="13.5" cy="13.5" r="2.5" fill="white" {...props} />
			<path
				d="M13.5 10C12.674 10 11.918 10.287 11.316 10.77C10.511 11.407 10 12.394 10 13.5C10 14.158 10.182 14.774 10.511 15.299C11.113 16.314 12.219 17 13.5 17C14.382 17 15.187 16.678 15.803 16.125C16.076 15.894 16.314 15.614 16.496 15.299C16.818 14.774 17 14.158 17 13.5C17 11.568 15.432 10 13.5 10ZM15.313 13.122L13.444 14.844C13.318 14.963 13.157 15.019 12.996 15.019C12.828 15.019 12.66 14.956 12.534 14.83L11.673 13.962C11.414 13.703 11.414 13.29 11.673 13.031C11.932 12.772 12.345 12.772 12.604 13.031L13.017 13.444L14.424 12.149C14.69 11.904 15.103 11.918 15.348 12.184C15.593 12.457 15.579 12.877 15.313 13.122Z"
				fill="#7D7D7D"
				{...props}
			/>
		</svg>
	);
}

export function ActiveIcon(props: Props) {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx="7.08333" cy="7.08333" r="4.58333" fill="white" {...props} />
			<path
				d="M7.5 1.25C4.05625 1.25 1.25 4.05625 1.25 7.5C1.25 10.9438 4.05625 13.75 7.5 13.75C10.9438 13.75 13.75 10.9438 13.75 7.5C13.75 4.05625 10.9438 1.25 7.5 1.25ZM10.4875 6.0625L6.94375 9.60625C6.85625 9.69375 6.7375 9.74375 6.6125 9.74375C6.4875 9.74375 6.36875 9.69375 6.28125 9.60625L4.5125 7.8375C4.33125 7.65625 4.33125 7.35625 4.5125 7.175C4.69375 6.99375 4.99375 6.99375 5.175 7.175L6.6125 8.6125L9.825 5.4C10.0063 5.21875 10.3063 5.21875 10.4875 5.4C10.6688 5.58125 10.6688 5.875 10.4875 6.0625Z"
				fill="#00C853"
				{...props}
			/>
		</svg>
	);
}
